var _style, _rect, _polygon, _polygon2, _polygon3, _path, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path2, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _path3, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOilgasM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "oil_refining",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 800",
    style: {
      enableBackground: "new 0 0 1200 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000152956433348309942010000017548060113748382627_);}\r\n\t.st2{fill:url(#SVGID_00000081610230059211184080000007229798426357371041_);}\r\n\t.st3{fill:url(#SVGID_00000138544826882075354560000010695337658360536711_);}\r\n\t.st4{fill:url(#SVGID_00000179640731442775521270000003292640857404991666_);}\r\n\t.st5{fill:url(#SVGID_00000043426645041771257600000009281856988932276388_);}\r\n\t.st6{fill:url(#SVGID_00000174585842979301535370000007882638720442204557_);}\r\n\t.st7{fill:url(#SVGID_00000090295449194626085180000011861516481874878135_);}\r\n\t.st8{fill:url(#SVGID_00000077310863462412661960000004273367135538830781_);}\r\n\t.st9{fill:url(#SVGID_00000130636408012116559470000017333945085411431302_);}\r\n\t.st10{fill:#FFFFA4;}\r\n\t.st11{opacity:0.37;fill:#C94E6C;enable-background:new    ;}\r\n\t.st12{fill:url(#SVGID_00000175290741190224332390000013148207589775277980_);}\r\n\t.st13{opacity:0.81;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st14{fill:url(#SVGID_00000003071976674812012990000004692614322512321961_);}\r\n\t.st15{opacity:0.1;fill:#A2004F;enable-background:new    ;}\r\n\t.st16{fill:url(#SVGID_00000084509306844280543970000016773300784048058040_);}\r\n\t.st17{fill:url(#SVGID_00000011012339513842476320000002490940984082609819_);}\r\n\t.st18{fill:url(#SVGID_00000146457658485924495740000008322167414468657078_);}\r\n\t.st19{fill:url(#SVGID_00000029003649618858032740000001228829365355941264_);}\r\n\t.st20{fill:url(#SVGID_00000161599582711462028120000011401788459596782261_);}\r\n\t.st21{fill:url(#SVGID_00000019648493254156126760000003929788143703291580_);}\r\n\t.st22{fill:url(#SVGID_00000098931055325540942070000005559156947960954026_);}\r\n\t.st23{fill:url(#SVGID_00000114781283317016577060000006233238587721393552_);}\r\n\t.st24{fill:url(#SVGID_00000042724280646598139130000013595946601167187133_);}\r\n\t.st25{fill:url(#SVGID_00000061464738250156747740000008507532605124549003_);}\r\n\t.st26{opacity:0.37;fill:#860E37;enable-background:new    ;}\r\n\t.st27{fill:url(#SVGID_00000170969893709597744820000016056639279428943520_);}\r\n\t.st28{opacity:0.53;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st29{fill:url(#SVGID_00000025439453683723016680000011891540925995945911_);}\r\n\t.st30{fill:url(#SVGID_00000050654065293816258150000015460221621020593310_);}\r\n\t.st31{fill:url(#SVGID_00000098907797492201104920000007364607659400250283_);}\r\n\t.st32{opacity:0.55;}\r\n\t.st33{fill:url(#SVGID_00000137833814687919805430000003078051924031448221_);}\r\n\t.st34{fill:url(#SVGID_00000101782561904049634750000005231704019074485692_);}\r\n\t.st35{fill:url(#SVGID_00000120547426950113241420000003242314071625475731_);}\r\n\t.st36{fill:#FFFFFF;}\r\n\t.st37{opacity:0.15;fill:url(#SVGID_00000003792464430680485330000007887370134125968782_);enable-background:new    ;}\r\n\t.st38{fill:url(#SVGID_00000145765390612560166520000018233533992761661112_);}\r\n\t.st39{fill:url(#SVGID_00000052783587767583218250000012121601963461131962_);}\r\n\t.st40{fill:url(#SVGID_00000045582058334862061860000015223319743145106099_);}\r\n\t.st41{opacity:0.36;fill:#093668;enable-background:new    ;}\r\n\t.st42{opacity:0.43;fill:#9D1146;enable-background:new    ;}\r\n\t.st43{opacity:0.15;fill:url(#SVGID_00000110463283287956151170000008129974613151085210_);enable-background:new    ;}\r\n\t.st44{fill:url(#SVGID_00000024705663718193411020000006081871531222854327_);}\r\n\t.st45{opacity:0.2;fill:#A2004F;enable-background:new    ;}\r\n\t.st46{fill:url(#SVGID_00000081631518698945136460000013514326948040019897_);}\r\n\t.st47{fill:url(#SVGID_00000014596616806805633880000005851036567885983392_);}\r\n\t.st48{fill:url(#SVGID_00000101103802104943207270000012207753806307793290_);}\r\n\t.st49{opacity:0.55;fill:url(#SVGID_00000083068868813030006460000010014512358964426167_);enable-background:new    ;}\r\n\t.st50{fill:url(#SVGID_00000043430526905940445880000018037651087420339120_);}\r\n\t.st51{opacity:0.55;fill:url(#SVGID_00000134932746437624538550000012964588719118906761_);enable-background:new    ;}\r\n\t.st52{fill:url(#SVGID_00000039129791042483007750000008110782664830531998_);}\r\n\t.st53{fill:url(#SVGID_00000115475752078673122350000000123259502783998114_);}\r\n\t.st54{fill:url(#SVGID_00000137840868196498245250000004533750918042479544_);}\r\n\t.st55{fill:url(#SVGID_00000157296531572210186230000006784649169983179948_);}\r\n\t.st56{fill:url(#SVGID_00000183218075122831824630000004229301123993277866_);}\r\n\t.st57{opacity:0.55;fill:url(#SVGID_00000106835136029269039940000011028727795760596865_);enable-background:new    ;}\r\n\t.st58{opacity:0.55;fill:url(#SVGID_00000090253936537618356460000013949394133020947134_);enable-background:new    ;}\r\n\t.st59{fill:url(#SVGID_00000106851678850193635240000006174908244546159771_);}\r\n\t.st60{fill:url(#SVGID_00000083791528501654578910000017573076468887237514_);}\r\n\t.st61{fill:url(#SVGID_00000162330896945298253070000002240271064341976480_);}\r\n\t.st62{fill:url(#SVGID_00000140721866229345727860000016805512450100351136_);}\r\n\t.st63{fill:url(#SVGID_00000017515566913939528880000006470882809386479281_);}\r\n\t.st64{fill:url(#SVGID_00000087378933766540235780000007044784219477622924_);}\r\n\t.st65{opacity:0.55;fill:url(#SVGID_00000111186625676704215660000006925464295020572297_);enable-background:new    ;}\r\n\t.st66{fill:url(#SVGID_00000029732021386935465150000015057154811179425963_);}\r\n\t.st67{fill:url(#SVGID_00000165917475020310259970000014480588717720375205_);}\r\n\t.st68{fill:url(#SVGID_00000099642811534027333110000007526284928897295534_);}\r\n\t.st69{fill:url(#SVGID_00000023997751771409742450000013071926294914810248_);}\r\n\t.st70{fill:url(#SVGID_00000036252907704994188840000005469432924988088759_);}\r\n\t.st71{fill:url(#SVGID_00000016782223339105247540000010553078004577639301_);}\r\n\t.st72{fill:url(#SVGID_00000177481481334491551960000000468008716700070832_);}\r\n\t.st73{fill:url(#SVGID_00000099662431619453760840000009481023434682325180_);}\r\n\t.st74{fill:url(#SVGID_00000104680015286867765090000001011086754757137816_);}\r\n\t.st75{fill:url(#SVGID_00000162353659013270706740000004786125926802294460_);}\r\n\t.st76{fill:url(#SVGID_00000017510438473847755010000012278818487437442701_);}\r\n\t.st77{fill:url(#SVGID_00000085968551611030212070000010487837218373166267_);}\r\n\t.st78{fill:url(#SVGID_00000111165750776752400770000007306215689031170180_);}\r\n\t.st79{fill:url(#SVGID_00000116194043389932310470000002731354490679712648_);}\r\n\t.st80{fill:url(#SVGID_00000176017794902410770170000017586824912567116731_);}\r\n\t.st81{fill:url(#SVGID_00000072977121557690206630000004935386616833873575_);}\r\n\t.st82{fill:url(#SVGID_00000071552921188336195790000012356965905407945347_);}\r\n\t.st83{fill:url(#SVGID_00000121989593986004342610000007654178328360431022_);}\r\n\t.st84{opacity:0.15;fill:url(#SVGID_00000020392087232714495510000004963521606329508792_);enable-background:new    ;}\r\n\t.st85{fill:url(#SVGID_00000102538789913745106920000015040409880510285483_);}\r\n\t.st86{fill:url(#SVGID_00000034080020366479197470000015824337563587136419_);}\r\n\t.st87{fill:url(#SVGID_00000060752949860790278820000013884513978998760381_);}\r\n\t.st88{fill:url(#SVGID_00000139268014373827375290000008264322149235356339_);}\r\n\t.st89{fill:url(#SVGID_00000068660012821145991840000013582042620741514918_);}\r\n\t.st90{fill:url(#SVGID_00000012465774111019492840000011362738734786126011_);}\r\n\t.st91{fill:url(#SVGID_00000075130917036882441430000004588615097977290907_);}\r\n\t.st92{opacity:0.55;fill:url(#SVGID_00000000924556316680530610000003620179930103215233_);enable-background:new    ;}\r\n\t.st93{fill:url(#SVGID_00000140728521217038451840000012027982316396489382_);}\r\n\t.st94{fill:url(#SVGID_00000007422219926703579080000015843848917672588199_);}\r\n\t.st95{fill:url(#SVGID_00000042698081085118465130000002937931047767362214_);}\r\n\t.st96{fill:url(#SVGID_00000015356578601731733460000011188528629695519110_);}\r\n\t.st97{fill:url(#SVGID_00000082369167301186851080000017859183722433504926_);}\r\n\t.st98{fill:url(#SVGID_00000093175898409306265940000018247768524701307031_);}\r\n\t.st99{fill:url(#SVGID_00000101814176533041366930000004634989104805280180_);}\r\n\t.st100{fill:url(#SVGID_00000065067965326319014040000007958264469028581268_);}\r\n\t.st101{fill:url(#SVGID_00000052102564382869535270000004822341219010196101_);}\r\n\t.st102{fill:url(#SVGID_00000111891475675886315740000007369925819564540551_);}\r\n\t.st103{fill:url(#SVGID_00000125567083783879878760000005837538849479489468_);}\r\n\t.st104{fill:url(#SVGID_00000119797101679893328010000013779657998716975240_);}\r\n\t.st105{fill:url(#SVGID_00000113317033022104191830000002866061979483139464_);}\r\n\t.st106{fill:url(#SVGID_00000060024779070695848110000017861692599543161006_);}\r\n\t.st107{fill:url(#SVGID_00000048490501569814473840000013870837735503913351_);}\r\n\t.st108{fill:url(#SVGID_00000032622102765633217320000004122570746924955047_);}\r\n\t.st109{fill:url(#SVGID_00000160905211169159084780000009522106905085709735_);}\r\n\t.st110{fill:url(#SVGID_00000058572980630969457620000005328202061976772494_);}\r\n\t.st111{fill:url(#SVGID_00000060713516651151650280000011862186815334004911_);}\r\n\t.st112{fill:url(#SVGID_00000098214251555815087360000001454256964300756639_);}\r\n\t.st113{fill:url(#SVGID_00000106139891364496355790000004693662690795366552_);}\r\n\t.st114{opacity:0.55;fill:url(#SVGID_00000158749111262286205620000008634221580343426969_);enable-background:new    ;}\r\n\t.st115{opacity:0.21;fill:url(#SVGID_00000058588105529022544620000004709562725456487323_);enable-background:new    ;}\r\n\t.st116{opacity:0.55;fill:url(#SVGID_00000092455247457243421160000013702155069323967928_);enable-background:new    ;}\r\n\t.st117{fill:url(#SVGID_00000116927088002448208980000002127560276210581692_);}\r\n\t.st118{opacity:0.31;fill:#A2004F;enable-background:new    ;}\r\n\t.st119{fill:url(#SVGID_00000132767179210209361790000014927347606127958458_);}\r\n\t.st120{opacity:0.55;fill:url(#SVGID_00000169533126690973035510000000474246299327378597_);enable-background:new    ;}\r\n\t.st121{fill:url(#SVGID_00000170277588772460137700000017542212168089095095_);}\r\n\t.st122{fill:url(#SVGID_00000132075300666969196720000009781890093128141453_);}\r\n\t.st123{fill:url(#SVGID_00000160892685097336460480000005610746747475290753_);}\r\n\t.st124{fill:url(#SVGID_00000085951676263847987760000003201675328457710986_);}\r\n\t.st125{opacity:0.55;fill:url(#SVGID_00000134956978808450504630000015151155315001814421_);enable-background:new    ;}\r\n\t.st126{fill:url(#SVGID_00000121255435694993341080000000337129071593869226_);}\r\n\t.st127{opacity:0.55;fill:url(#SVGID_00000037657747591996963350000012791496875232887695_);enable-background:new    ;}\r\n\t.st128{fill:url(#SVGID_00000101094020692796737370000010616638542643954869_);}\r\n\t.st129{fill:url(#SVGID_00000163031324751619673680000010429830408547007647_);}\r\n\t.st130{fill:url(#SVGID_00000090982317363496841600000006482351677405599669_);}\r\n\t.st131{fill:url(#SVGID_00000179628600337853143270000003499583094724397489_);}\r\n\t.st132{opacity:0.55;fill:url(#SVGID_00000116228124039415402820000003039712278505703073_);enable-background:new    ;}\r\n\t.st133{fill:url(#SVGID_00000113355298233563016420000016065174542339689876_);}\r\n\t.st134{opacity:0.55;fill:url(#SVGID_00000165229053633927150450000016410732596554342804_);enable-background:new    ;}\r\n\t.st135{fill:url(#SVGID_00000175317279630758608600000014404560757812193697_);}\r\n\t.st136{fill:url(#SVGID_00000183206519886517269210000006785819650687737506_);}\r\n\t.st137{fill:url(#SVGID_00000015333122212120565780000003531992528439136146_);}\r\n\t.st138{fill:url(#SVGID_00000077297535001833841870000006545734540820394931_);}\r\n\t.st139{opacity:0.55;fill:url(#SVGID_00000011734018737634907230000001429700719725366180_);enable-background:new    ;}\r\n\t.st140{fill:url(#SVGID_00000126317670317861535380000014567775903047355790_);}\r\n\t.st141{opacity:0.55;fill:url(#SVGID_00000026123340560562922690000018000662092820637616_);enable-background:new    ;}\r\n\t.st142{fill:url(#SVGID_00000149362411875580878910000008340485717453216422_);}\r\n\t.st143{fill:url(#SVGID_00000108281574992165917010000015817918927160832136_);}\r\n\t.st144{fill:url(#SVGID_00000181071247161056794950000013814407610791750556_);}\r\n\t.st145{fill:url(#SVGID_00000034056331968136316000000016234662853491712692_);}\r\n\t.st146{opacity:0.55;fill:url(#SVGID_00000000907722297446542310000003531831878879399597_);enable-background:new    ;}\r\n\t.st147{fill:url(#SVGID_00000073681141661498845860000008257058855369645467_);}\r\n\t.st148{opacity:0.55;fill:url(#SVGID_00000133496872902567748270000001850655875844979622_);enable-background:new    ;}\r\n\t.st149{fill:url(#SVGID_00000112634143356296798570000005557615446929982356_);}\r\n\t.st150{fill:url(#SVGID_00000002364222775007190830000007587222282714222231_);}\r\n\t.st151{fill:url(#SVGID_00000062169790502683617240000012145885380276171154_);}\r\n\t.st152{fill:url(#SVGID_00000003107145242776292530000003886976152721421195_);}\r\n\t.st153{opacity:0.55;fill:url(#SVGID_00000061462366510525837100000016526981925502949534_);enable-background:new    ;}\r\n\t.st154{fill:url(#SVGID_00000070824391685711245890000011163139788128709277_);}\r\n\t.st155{fill:url(#SVGID_00000054945340746182130930000000689245611372226233_);}\r\n\t.st156{opacity:0.55;fill:url(#SVGID_00000129909463954858724080000006569719085507788692_);enable-background:new    ;}\r\n\t.st157{fill:url(#SVGID_00000113313306760399268390000006585718154001008279_);}\r\n\t.st158{fill:url(#SVGID_00000106846836048827148720000003808016277698795649_);}\r\n\t.st159{fill:url(#SVGID_00000103253189534389743330000016042068679045853622_);}\r\n\t.st160{fill:url(#SVGID_00000178164002592303238340000006057303368793018262_);}\r\n\t.st161{opacity:0.55;fill:url(#SVGID_00000153706426320718987450000006091794879757245318_);enable-background:new    ;}\r\n\t.st162{fill:url(#SVGID_00000072247025547672187910000011519860644122803856_);}\r\n\t.st163{fill:url(#SVGID_00000065785223391016484590000007158509320598779276_);}\r\n\t.st164{fill:url(#SVGID_00000155825269248078525820000011670086306830548119_);}\r\n\t.st165{fill:url(#SVGID_00000060721989752764877000000009337902042911873165_);}\r\n\t.st166{fill:url(#SVGID_00000036973704438977876240000009126573835573029298_);}\r\n\t.st167{fill:url(#SVGID_00000072993810312715903370000017386708868442000021_);}\r\n\t.st168{fill:url(#SVGID_00000142150697275629779960000002493966503841010103_);}\r\n\t.st169{fill:url(#SVGID_00000005230434207814832450000005405326196761888940_);}\r\n\t.st170{fill:url(#SVGID_00000006684280217471043170000002484820938862755723_);}\r\n\t.st171{fill:url(#SVGID_00000066500374848433827450000015217153021003327403_);}\r\n\t.st172{fill:url(#SVGID_00000052800870126681898230000014841430679454391968_);}\r\n\t.st173{fill:url(#SVGID_00000022558173683365883650000013843420685538409093_);}\r\n\t.st174{fill:url(#SVGID_00000069394648398744552330000002310541784677440700_);}\r\n\t.st175{fill:url(#SVGID_00000119084927031864091300000015378654041797364628_);}\r\n\t.st176{fill:url(#SVGID_00000072983039464552353440000010949522009117849746_);}\r\n\t.st177{fill:url(#SVGID_00000124119262592687062110000003542591140982984845_);}\r\n\t.st178{fill:url(#SVGID_00000068639573490817816250000014563914465080667307_);}\r\n\t.st179{fill:url(#SVGID_00000048494631178341421400000008461129158114781070_);}\r\n\t.st180{fill:url(#SVGID_00000165934468343470447230000008673981546585390525_);}\r\n\t.st181{fill:url(#SVGID_00000142888221007635233320000014397381875762057349_);}\r\n\t.st182{fill:url(#SVGID_00000094613566756209543860000003122183910733458839_);}\r\n\t.st183{fill:url(#SVGID_00000016797036189217944710000000800668507806417024_);}\r\n\t.st184{opacity:0.57;fill:#9D1146;enable-background:new    ;}\r\n\t.st185{fill:url(#SVGID_00000098942407052620486850000002559512146278935960_);}\r\n\t.st186{fill:url(#SVGID_00000036962870399298234120000016389776182718061478_);}\r\n\t.st187{fill:url(#SVGID_00000118376256955877788630000011563693866526190230_);}\r\n\t.st188{fill:url(#SVGID_00000052074438885002720180000005952206288909314471_);}\r\n\t.st189{fill:url(#SVGID_00000085941022563072559760000012373521519610925756_);}\r\n\t.st190{fill:url(#SVGID_00000084503171605297325690000001747252703225523375_);}\r\n\t.st191{fill:url(#SVGID_00000030487513013696276940000011704372545286751662_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 292.1796,
    cy: -392.6331,
    r: 73.2391,
    gradientTransform: "matrix(0.625 0 0 -0.7301 244.3113 -218.4457)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 426.8,
    y: 61.6,
    className: "st0",
    width: 1.5,
    height: 73.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000059296163672639671880000012511270873865843077_",
    cx: 170.2929,
    cy: -310.3728,
    r: 73.2391,
    gradientTransform: "matrix(0.625 0 0 -0.7301 244.3113 -218.4457)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 350.6,
    y: 1.5,
    style: {
      fill: "url(#SVGID_00000059296163672639671880000012511270873865843077_)"
    },
    width: 1.5,
    height: 73.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043448308020901986660000004006511506213150096_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.3222,
    y1: 383.2603,
    x2: 351.3222,
    y2: 387.1273,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 350.6,
    y: 14.8,
    style: {
      fill: "url(#SVGID_00000043448308020901986660000004006511506213150096_)"
    },
    width: 1.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000088828426186286079980000014753336319663290022_",
    cx: 338.5032,
    cy: -1261.7031,
    r: 73.2421,
    gradientTransform: "matrix(0.625 0 0 -0.4057 244.3113 -414.1237)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 455.7,
    y: 94.1,
    style: {
      fill: "url(#SVGID_00000088828426186286079980000014753336319663290022_)"
    },
    width: 1.5,
    height: 40.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100353130713761880850000000099939775208559015_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.5208,
    y1: -385.7404,
    x2: 343.5208,
    y2: 148.4984,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B839D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100353130713761880850000000099939775208559015_)"
    },
    d: "M372.4,253.5h-14.2 c-36.5,0-66.8,41.1-71,93.9h-11.2l0.2,9h-7l3.2,27.1h4.2l1.7,97.3l-7.1,0.5l-2.9,12.2l-9.8-0.5l-9.2,238l0,0l-1.1,26.4l-4.5-0.2 l-6.7,30.5h124.5l-3.9-25.1l-7.4-0.5l-14.7-266.4l-4.8-0.2l0,0h-2.7l-4.7-16.9l-6.8,0.5l0.8-56.4l0.5-38.8h2.9l2.1-27.1h-4.7 l0.2-6.1l0,0v-2.7h-8.6c4.1-34.8,24.5-61.2,48.9-61.2h14.2c30.8,0,55.9,37.3,56,83.1l-8.9,265.5c0,0.5,0,0.7,0,1.1h3.2h5.6h13 l8.9-265.3v-0.9C450.2,305.4,415.2,253.5,372.4,253.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154418413708079700300000017564927859914195611_",
    gradientUnits: "userSpaceOnUse",
    x1: 738.9693,
    y1: -392.0628,
    x2: 738.9693,
    y2: 40.278,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B839D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154418413708079700300000017564927859914195611_)"
    },
    d: "M888.5,494v-0.9c0-5.6-0.3-11.1-0.8-16.5 l0,0l-0.2-2c0-0.7-0.2-1.4-0.2-2l-0.2-1.1l2.3-0.9l-0.3-2l-2.3,0.7c-2-15.4-5.6-29.8-10.9-42.7l0,0l-0.2-0.2 c-0.3-0.7-0.5-1.1-0.8-1.8l-1.1-2.7l2.1-2.5l-2-3.8l-2,2.5c-6.5-13.5-14.5-25.1-23.9-34.1l0,0l-1.1-0.9c-0.5-0.5-0.9-0.9-1.5-1.4 l-0.8-0.7l1.8-4.5l-3.5-1.4l-1.2,3.4c-12.1-9.7-26.1-15.1-40.7-15.1h-1.2h-1.8v-2h-3v2h-9.5c-11.4,0-22.1,3.6-32,9.9l-2-4.1l-2,2 l1.7,3.6l-0.2,0.2c-0.3,0.2-0.6,0.5-0.9,0.7l-1.7,1.1l0,0c-12.4,9.7-22.9,24.2-30.4,41.5l-4.1-2.3l-0.8,4.1l3.3,1.8l0,0l0,0 l-0.8,2c-0.3,0.7-0.6,1.6-0.9,2.3l-0.2,0.5l0,0c-1.2,3.6-2.4,7.2-3.5,11.1l-72.9,0.2l-7.3,9.3l0,0l-16.2-0.2l-4.2,8.4l96.3,3.6 l0,0l-106.6-4.1l0.3,6.8l-12.6-0.2l2.3,10.2h4.5l6.8,16.5l11.8,285.2l0,0l0.9,20.8l143-1.4v0.5h1.8v-0.5l19.5-0.2v0.7h1.7v-0.7 l52.4-0.5L848,475.5l8.8,0.2l2.9-7l-11.5-0.2l0.2-3.4l-115.9-4.5l0,0l107.1,4.1l-3.2-13.3l-13.2-0.2l-8.8-13.1l-75.1,0.2 c0.2-0.5,0.3-0.7,0.5-1.1l0.3-0.7c0.2-0.5,0.3-0.7,0.5-0.9l2,1.1l0.9-3.6l-1.1-1.1c6.1-11.5,14.1-20.5,23.2-26l1.2,2.7l2.4-1.8 l-1.1-2.3c5.6-2.9,11.5-4.3,17.7-4.3h10.3v2h1.1v-2h2h2.4c10.6,0,20.6,4.1,29.4,11.1l-1.1,2.9l1.4,2.5l1.5-3.6 c0.2,0.2,0.5,0.2,0.6,0.5l0.6,0.7c7.9,7.2,14.5,16.9,19.7,28.5l-1.7,2l0.9,2l1.7-1.8l0,0l0.2,0.5c4.1,9.9,6.8,21,8.2,32.7 l-1.2,0.5l0.3,4.3l1.4-0.7c0,0.2,0,0.7,0.2,0.9v0.9c0.2,2.9,0.3,6.1,0.3,9l-1.2,37.3l-2.9-0.2l-0.3,4.5l3,0.2v1.4l0,0l-1.8,53.3 l-2.3-0.2l-0.3,4.5l2.6,0.2l-2,60.1l-0.2,3.6l-1.8,54.4h-3.2v3.6h3v0.9l-1.7,50.4l-2.1-0.2l-0.3,4.5l2.4,0.2l-0.6,17.8 c0,0.5,0,0.7,0,1.1h3.6h6.2h14.5l0.6-17.8h1.5v-4.1h-1.4l1.7-47.4l0,0l0.2-3.6v-2h2v-3.6h-1.8l1.7-48.5l0,0v-1.1l0.2-5h2.1v-3.6 h-2.1l2-58v-0.9l0,0l0,0h1.4v-4.1h-1.2l1.8-54.9h2.1v-4.1l-2-0.2L888.5,494z M597.9,471.8h3.8l0.5,12.2L597.9,471.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119118962939658074950000008360757103309461153_",
    gradientUnits: "userSpaceOnUse",
    x1: 847.3334,
    y1: -80.7998,
    x2: 854.4217,
    y2: -80.7998,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B839D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000119118962939658074950000008360757103309461153_)"
    },
    points: "852.9,475.2 847.4,487.9  847.3,490.4 854.4,475.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078735325870480518570000009916840249694843539_",
    gradientUnits: "userSpaceOnUse",
    x1: 937.1854,
    y1: -392.5142,
    x2: 937.1854,
    y2: 293.2188,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B839D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078735325870480518570000009916840249694843539_)"
    },
    d: "M962.1,110.1l-0.2,1.8l0.5-3.8h-56.5 l2.4,24.8h-1.5l2,10.4h7.3l-1.5,36.1h-10.9l2.6,27.1h0.9h0.2l-1.4-22.8h2l2.3,23l-5.6-0.2l2.1,11.3h6.4v1.4l-0.2,3.2l0,0 l-2.1,53.3h-9.7l2.9,27.1h-1.8l2.3,11.3h4.8l-2.3,54.4h-8.8l3.2,27.1h1.1h0.2l-1.7-22.8h2.4l2.6,23v0.2l-6.5-0.2l2.4,11.3h3.6v0.5 l-0.2,2l0,0l-2.3,55.5l-0.2,3.8h-10.6l3.6,27.1h1.2h0.2l-2-22.8h2.7l3,23l-7.6-0.2l2.9,11.3h5l-0.3,5.6l0,0l-3,73.4h-12.9 l4.2,27.1h1.4l0,0h-4.1l3.3,11.3h6.4l-5.8,139.5l-4.4-0.2l-5.8,30.5h106.2l-3.5-25.1l-5.6-0.2l-5.3-127.8l0,0l-0.6-16.7h6.5 l2.3-5.6l6.4,175.2h7.1l-31.7-686.2L962.1,110.1z M946,134.1l0.2-1.8L946,134.1L946,134.1z M912.1,133.2l-1.1-19.2h8.9l0.9,19.4 h0.5h0.3L912.1,133.2z M921.8,114h0.5h-0.2l0.9,19.4h-1.4L921.8,114z M923.5,114l22.1-0.2v20.3l-22.1-0.7V114z M909.7,111.5 L909.7,111.5h-2.3H909.7z M909.7,111.9l2.1,21.2h-2.6l-1.4-21L909.7,111.9z M946.2,134.1h0.5h0.3l1.1-20.3h11.4l-2.1,20.5 L946.2,134.1z M960,111.7h1.1l-2,22.8h-1.4L960,111.7z M960,111.2L960,111.2h1.4H960z M909.1,133.2L909.1,133.2h-0.3H909.1z  M959.1,143.5l2.3-9h-1.8l0,0l2.3-21.2v1.6l2.4,65h-11.5l-1.5-36.1h7.9V143.5z M971.3,497.1h-2.1l3.5-24.6h1.5L971.3,497.1z  M908.2,302.7l-1.4-20.8h3.3l-0.9,20.8H908.2z M965.9,496.9l-0.9-22.4h6.7l-3.2,22.4H965.9z M973,471.8L973,471.8h1.8l0,0H973z  M961.7,396.9l-0.9-22.4h5.6l-2.7,22.4H961.7z M967.4,372h1.4l-2.6,24.8h-1.8L967.4,372z M967.4,371.6L967.4,371.6h1.7H967.4z  M957.9,303.9l-0.9-22.4h7l-2.4,22.4H957.9z M964.7,279.2h1.2l-2.4,24.8h-1.7L964.7,279.2z M964.7,278.8L964.7,278.8h1.5H964.7z  M953.8,207.9l-0.9-22.1h8.5l-2.3,22.4L953.8,207.9z M962.3,183.3h1.2l-2.1,24.8h-1.5L962.3,183.3z M962.3,182.8L962.3,182.8h1.5 H962.3z M905.3,279.2L905.3,279.2h-2.7H905.3z M905.3,279.7l2.4,23h-3l-1.5-22.8L905.3,279.7z M887.4,589.5h4.1l0,0H887.4 L887.4,589.5z M897.3,592.2l-0.9,20.8h-0.8l-2-20.8H897.3z M970,592h8l-3.6,22.4h-3.5L970,592z M979.1,591.1l0.3,10.4l-1.8,12.9 h-2.4L979.1,591.1z M969.7,585.9l-2.6-61.9l0,0l-0.5-9.5l-0.3-7.7h5.3l3.3-9.7h-2.7l2.7-18.7l3.9,107.7h-9.2V585.9z M964.7,468.5 l-2.6-61.9h4.1l2.9-9.7h-2.3l0,0l3.5-28.5h-9.8l-0.8-17.2l-1.1-24.6l0,0l-0.2-3.4l-0.5-9.5h5.5l2.6-9.7h-2.1l0,0l3.2-28.5h-10.8 l-2.4-57.6h7.1l2.4-9.7h-2l2.6-24.2l10.3,284.5h-9.7V468.5z M905,183.3L905,183.3h2.6l0,0H905z M909.1,186h5l-0.9,21h-3L909.1,186 z M904.5,302.7L904.5,302.7L904.5,302.7L904.5,302.7z M899.8,372h3l0,0H899.8z M904.5,374.8h1.8l-0.8,16.7L904.5,374.8z  M894.1,472.1L894.1,472.1h3.5l0,0H894.1z M899.5,475h2.6l-0.9,20.8h-0.2L899.5,475z M888.3,590.2h3.2l3.6,23h-4.5L888.3,590.2z  M978.6,614.3l1.1-6.5l0.3,6.5H978.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176743687273765684820000015821189481477744266_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.4718,
    y1: -361.3506,
    x2: 598.2769,
    y2: 40.602,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176743687273765684820000015821189481477744266_)"
    },
    d: "M927.7,553.8L927.7,553.8 c0-19.2-10.5-34.5-23.3-34.3l-801.7,14.2c-22.4,0.5-40.3,27.5-40.3,61l0,0h33l0,0c-0.5-21.9,11.2-40.2,25.9-40.4l777-12.9 c4.5,0,8.3,5.4,8.3,12.4l0,0L927.7,553.8L927.7,553.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152251745635318709340000016346976042537107126_",
    gradientUnits: "userSpaceOnUse",
    x1: 861.8224,
    y1: -281.0829,
    x2: 973.7688,
    y2: -281.0829,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4EDA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4AC88"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000152251745635318709340000016346976042537107126_)"
    },
    points: "865.3,787.1 861.8,607.3  890.8,577.7 943.6,577.7 973.8,608.9 969.7,788.4  "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "864.1,612.7 868.3,779.4 880.2,779.2 877.4,612.7 892.3,584.5 943,584.5 890.9,580.5  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "939.2,611.6 970.4,611.6 965,783.7 939.2,783.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121271158403184599210000001913550679486576817_",
    gradientUnits: "userSpaceOnUse",
    x1: 917.1897,
    y1: -175.748,
    x2: 917.1897,
    y2: -150.2327,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121271158403184599210000001913550679486576817_)"
    },
    points: "890.8,577.7 896.5,552.2  939.2,552.2 943.6,577.7  "
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "893.9,575.5 897.4,556.7 906.5,556.7 906.5,574.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145741068739720071710000010330365980772983191_",
    gradientUnits: "userSpaceOnUse",
    x1: 861.8224,
    y1: -215.8272,
    x2: 973.7688,
    y2: -215.8272,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145741068739720071710000010330365980772983191_)"
    },
    points: "973.8,608.9 861.8,607.3  862.3,628.3 973.8,627.6  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M865.3,787.1c0,0,62-6.3,81.5-35c23.6-34.8,26.5-124.6,26.5-124.6l-3.6,160.8L865.3,787.1z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "863.6,625.8 863,609.4 972.6,609.4 877,610.9 877.1,626.1  "
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "972.9,650.5 862.4,634.9 862.3,628.3 973.3,627.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083811425197210796800000014314308641520641164_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.3282,
    y1: -294.5179,
    x2: 128.7926,
    y2: -294.5179,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4EDA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4AC88"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000083811425197210796800000014314308641520641164_)"
    },
    points: "33.4,788 30.3,630.1  55.8,603.9 102.3,603.9 128.8,631.5 125.2,789.1  "
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "32.3,634.9 36.1,781.2 46.4,781 44,634.9 57.1,609.8 101.7,609.8 55.9,606.2  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "98.3,633.7 125.8,633.7 120.9,785 98.3,785  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055686732886698501880000013866016339436539036_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.0302,
    y1: -201.964,
    x2: 79.0302,
    y2: -179.5161,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000055686732886698501880000013866016339436539036_)"
    },
    points: "55.8,603.9 60.8,581.6  98.3,581.6 102.3,603.9  "
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "58.5,602.1 61.7,585.4 69.6,585.4 69.6,601  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101095452843190319510000007809133511619709362_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.3282,
    y1: -237.278,
    x2: 128.7926,
    y2: -237.278,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000101095452843190319510000007809133511619709362_)"
    },
    points: "128.8,631.5 30.3,630.1  30.8,648.4 128.8,647.7  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M33.4,788c0,0,54.4-5.4,71.7-30.7c20.8-30.5,23.3-109.5,23.3-109.5L125,789.1L33.4,788z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "31.8,646.4 31.4,631.9 127.6,633.7 43.7,635.1 43.8,646.4  "
  }))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "127.9,667.8 30.8,654.3 30.8,648.4 128.3,647.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000171697037915241225290000004834792352773506439_",
    cx: 844.4812,
    cy: -388.4177,
    r: 73.2392,
    gradientTransform: "matrix(0.625 0 0 -0.7301 244.3113 -218.4457)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 772,
    y: 58.6,
    style: {
      fill: "url(#SVGID_00000171697037915241225290000004834792352773506439_)"
    },
    width: 1.5,
    height: 73.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041294670225490014920000014313242281863786942_",
    gradientUnits: "userSpaceOnUse",
    x1: 772.7499,
    y1: 302.3262,
    x2: 772.7499,
    y2: 306.8705,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 772,
    y: 95.2,
    style: {
      fill: "url(#SVGID_00000041294670225490014920000014313242281863786942_)"
    },
    width: 1.5,
    height: 4.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062898665991434064440000018307934579674979460_",
    gradientUnits: "userSpaceOnUse",
    x1: 772.7499,
    y1: 326.2807,
    x2: 772.7499,
    y2: 330.148,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 772,
    y: 72,
    style: {
      fill: "url(#SVGID_00000062898665991434064440000018307934579674979460_)"
    },
    width: 1.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000039105746279686565880000003998324931948878779_",
    cx: 928.8563,
    cy: 62.2751,
    r: 73.2456,
    gradientTransform: "matrix(0.625 0 0 -1.1258 244.3113 97.5706)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 824.7,
    y: 17.3,
    style: {
      fill: "url(#SVGID_00000039105746279686565880000003998324931948878779_)"
    },
    width: 1.5,
    height: 112.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046316070661003079850000011977089574932468643_",
    gradientUnits: "userSpaceOnUse",
    x1: 825.4663,
    y1: 321.2712,
    x2: 825.4663,
    y2: 328.2795,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 824.7,
    y: 73.8,
    style: {
      fill: "url(#SVGID_00000046316070661003079850000011977089574932468643_)"
    },
    width: 1.5,
    height: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000168098471771023227120000003252312281031539359_",
    cx: 799.5625,
    cy: 421.9351,
    r: 136.7904,
    gradientTransform: "matrix(1 0 0 1.4906 0 -286.574)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168098471771023227120000003252312281031539359_)"
    },
    d: "M840.2,533.9L840.2,533.9l-0.5-10.4l0,0 l-4.8-99.4l0,0l0,0l-4.2-86.9l0,0l-0.2-4.5l0,0l-3.5-70l0,0l-0.3-7.5l0,0l-3.2-63l-0.2-3.8l0,0l-2.3-46.7v-5.2L807,86l-0.5-1.8 l0,0l-6.2-22.4l-6.5,22.4l0,0l0,0l-14.5,52.4v5.2l-2.7,52.6v0.2l0,0l-7,136.4l-0.3,6.3l0,0l-4.4,86.9l0,0l-0.3,7.5l0,0 l-9.7,191.3h8.3l3.5-72.9l27.1,33.2l-30.9,39.5h13l24.1-32.1l26.2,32.1h9.8l-30.6-39.3l27.3-36.4l3.2,75.6h8.3L840.2,533.9z  M771.4,445.4l24.5,35l-28.3,43.1l0,0L771.4,445.4z M800.6,486.8l25.8,36.8h-51.7L800.6,486.8z M775.9,350.4l20.5,33.4 l-23.9,40.4L775.9,350.4z M800.5,390.6l20.5,33.6h-38.8L800.5,390.6z M827.4,419.9l-22.9-37l19.7-36.1L827.4,419.9z M831.8,519 L805.3,480l23.3-33.2L831.8,519z M824.3,344.5l-0.3-7.2l-23.2,39.3l-24.1-39.3l0,0H824l0,0L824.3,344.5z M782.9,205l13.9,22.6 l-16.2,25.7L782.9,205z M785.6,149l12,17.2L784,184.6L785.6,149z M817.4,186.7l-13.9-21l12.3-17.8L817.4,186.7z M815.6,142 l-14.7,19.9L787.7,142H815.6L815.6,142z M800.3,170.4l12.4,18.1l-24.7-0.2L800.3,170.4z M820.5,255.5l-16.8-27.8l14.7-23.3 L820.5,255.5z M814.1,255.5h-28.2l14.2-22.6L814.1,255.5z M779.4,277.4l16.4,23.5l-18.3,28H777L779.4,277.4z M800,307.2 l17.1,24.6l-30.9-2.3L800,307.2z M823.3,332.3l-19.7-30.9l17.6-28.9l2.6,59.8H823.3z M820.8,263L799.7,295l-19.5-30.7v-0.2 L820.8,263L820.8,263z M810,117.3l-7.6-15.4l3-6.3L810,117.3z M799.9,69.5l4.1,19l-4.2,7.9l-3.8-7.9L799.9,69.5z M797.4,100.9 l-6.7,12.6l3.8-18.5L797.4,100.9z M800.3,106.5l12.9,25.3l1.1,4.7h-28.2L800.3,106.5z M817.7,193.7v0.9l-17.6,27.8l-16.8-27.8 l-0.3,7.7l0.3-7.7L817.7,193.7z M772.4,431.4H828l0,0l-27.3,41.8L772.4,431.4l-0.5,1.1v-1.1H772.4z M832.4,533.9l-32.7,41.8 l-32.4-41.8l0,0l0,0l0,0H832.4L832.4,533.9L832.4,533.9L832.4,533.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157992492612074487920000015558690186348178092_",
    gradientUnits: "userSpaceOnUse",
    x1: 712.7624,
    y1: -304.2272,
    x2: 878.6371,
    y2: -304.2272,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF666D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#920025"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000157992492612074487920000015558690186348178092_)"
    },
    points: "712.8,788.9 744.6,622.7  852.6,622.7 878.6,789.8  "
  }), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "748.2,626.1 715.8,787.5 736.8,787.5 765,626.1  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "825.3,626.1 842.9,787.5 874.1,787.5 846.5,626.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056420137389601706470000007767101657886823312_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.1051,
    y1: -528.8922,
    x2: 585.1203,
    y2: -528.8922,
    gradientTransform: "matrix(1.2499 0 0 -0.7878 139.5696 297.1302)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7653,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000056420137389601706470000007767101657886823312_)"
    },
    points: "732.2,687.5 862.6,687.5  870.9,740.1 722.2,740.1  "
  }), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "727.6,738.1 737,689.3 754.3,689.3 745.6,738.1  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "732.2,687.5 862.6,687.5 862.9,689.3 732,687.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086683382518670170730000000689668120477213357_",
    gradientUnits: "userSpaceOnUse",
    x1: 799.2596,
    y1: -220.9076,
    x2: 799.2596,
    y2: 340.2012,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#958893"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D1DE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086683382518670170730000000689668120477213357_)"
    },
    d: "M846.8,533.9L846.8,533.9l-0.6-10.4l0,0 l-5.8-99.4l0,0l0,0l-5-86.9l0,0l-0.3-4.5l0,0l-4.1-70l0,0l-0.5-7.5l0,0l-3.6-63l-0.2-3.8l0,0l-2.7-46.7v-5.2L807.7,86l-0.6-1.8 l0,0l-7.3-22.4l-7.3,22.4l0,0l0,0l-17,52.4v5.2l-3.2,52.6v0.2l0,0L764.3,331l-0.5,6.3l0,0l-5.2,86.9l0,0l-0.5,7.5l0,0 l-11.4,191.3h9.7l4.1-72.9l32,33.4l-36.1,39.5h15.1l28.2-32.1l30.6,32.1H842l-35.6-39.3l31.8-36.4l3.8,75.6h9.7L846.8,533.9z  M766.7,445.4l28.6,35l-33,43.1l0,0L766.7,445.4z M800.8,486.8l30.1,36.8h-60.3L800.8,486.8z M772,350.4l23.8,33.4l-27.9,40.4 L772,350.4z M800.6,390.6l23.9,33.6h-45.1L800.6,390.6z M832.1,419.9l-26.7-37l23-36.1L832.1,419.9z M837.1,519L806.2,480 l27.3-33.2L837.1,519z M828.3,344.5l-0.3-7.2l-27.1,39.3l-28.2-39.3l0,0H828l0,0L828.3,344.5z M780.2,205l16.4,22.6l-18.9,25.7 L780.2,205z M783.2,149l13.9,17.2l-15.9,18.5L783.2,149z M820.5,186.7l-16.4-21l14.4-17.8L820.5,186.7z M818.2,142l-17.1,19.9 L785.6,142H818.2L818.2,142z M800.5,170.4l14.5,18.1l-28.8-0.2L800.5,170.4z M824,255.5l-19.7-27.8l17.1-23.3L824,255.5z  M816.5,255.5h-32.9l16.7-22.6L816.5,255.5z M776.1,277.4l19.1,23.5l-21.5,28h-0.5L776.1,277.4z M800.2,307.2l20,24.6l-36.1-2.3 L800.2,307.2z M827.3,332.3l-23-30.9l20.5-28.9l3,59.8H827.3z M824.3,263L799.6,295l-22.9-30.7v-0.2L824.3,263L824.3,263z  M811.8,117.3L803,102l3.5-6.3L811.8,117.3z M800,69.5l4.7,19l-4.8,7.9l-4.5-7.9L800,69.5z M797.1,100.9l-7.9,12.6l4.5-18.5 L797.1,100.9z M800.5,106.5l15,25.3l1.2,4.7h-32.9L800.5,106.5z M820.8,193.7v0.9l-20.5,27.8l-19.7-27.8l-0.5,7.7l0.5-7.7 L820.8,193.7z M767.9,431.4h64.8l0,0l-32,41.8L767.9,431.4l-0.5,1.1v-1.1H767.9z M837.9,533.9l-38.2,41.8l-37.9-41.8l0,0l0,0l0,0 H837.9L837.9,533.9L837.9,533.9L837.9,533.9z"
  }), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "777.4,136.5 799,67.4 781.2,136.5 754.7,620 748.8,622.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153663980895546485780000017162214987017153197_",
    gradientUnits: "userSpaceOnUse",
    x1: 770.1014,
    y1: 256.0913,
    x2: 830.0773,
    y2: 256.0913,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF666D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#920025"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000153663980895546485780000017162214987017153197_)"
    },
    points: "770.2,130.2 772.7,161.6  827.7,161.6 830,130.2  "
  }), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "771.4,131.6 773.8,159.8 785,159.8 783.1,131.6  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "819.4,131.6 816.4,159.8 772.7,160.7 772.7,161.6 825.5,161.6 828,131.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173152271031305135400000016504958656093707672_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.3759,
    y1: -179.2366,
    x2: 361.0485,
    y2: 110.5869,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173152271031305135400000016504958656093707672_)"
    },
    d: "M351.3,369.6v0.9l-8.9,265.3h-22 c0-0.5,0-0.7,0-1.1l8.9-265.5c-0.2-45.8-25.1-83.1-56-83.1h-14.2c-27.4,0-49.7,33.2-49.7,74.1v31.2c0,9-4.8,16.3-10.9,16.3 c-6.1,0-10.9-7.2-10.9-16.3v-31.2c0-58.9,32.1-106.8,71.7-106.8h14.2C316.3,253.5,351.3,305.4,351.3,369.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159445042331568173120000000605976431463045001_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.8845,
    y1: -5.6952,
    x2: 285.3497,
    y2: 144.376,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159445042331568173120000000605976431463045001_)"
    },
    d: "M196.5,395.5v-29.6 c0-55.5,30.3-100.9,67.7-100.9h13.5c18.9,0,36.4,10.8,49.4,28.5c-13.5-22.1-32.9-36.1-54.5-36.1h-13.5 c-37.3,0-67.7,45.2-67.7,100.9v29.6c0,6.3,2.4,11.5,6.1,14C197,400,196.5,397.8,196.5,395.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080928558317208269800000008173376956666274699_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.9605,
    y1: -200.8423,
    x2: 387.8431,
    y2: 52.1041,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080928558317208269800000008173376956666274699_)"
    },
    d: "M338,377l-8.8,258.8h-5.6 c0-0.5,0-0.7,0-1.1l8.9-265.5c0-20.8-5.3-39.7-13.8-54.4C330.4,329.8,337.8,352.2,338,377z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032610725879987542870000007583808128601405334_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.4185,
    y1: -93.7305,
    x2: 233.3498,
    y2: 47.4426,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000032610725879987542870000007583808128601405334_)"
    },
    points: "216.8,505 179.7,505 177,347.2  218.9,347.2  "
  }), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "179.7,392.6 187.6,398.5 186.1,478.4 180.6,479.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106859678419352510660000004861620862212763811_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.5704,
    y1: -16.8988,
    x2: 218.471,
    y2: -16.8988,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "url(#SVGID_00000106859678419352510660000004861620862212763811_)",
      enableBackground: "new"
    },
    d: " M178.8,454.5c0,0,25-7.7,39.4-49.7l0.3-21.5h-40.9L178.8,454.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152228482216946848510000002493474719860014752_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.2172,
    y1: -382.5793,
    x2: 200.2172,
    y2: -90.8478,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D11D37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7052"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000152228482216946848510000002493474719860014752_)"
    },
    points: "148.2,784.6 159.5,492.8  236.3,495.6 252.3,783.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178885289296173531910000010292400739603700901_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.6474,
    y1: 12.3878,
    x2: 206.9735,
    y2: 54.2427,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000178885289296173531910000010292400739603700901_)"
    },
    points: "170.1,356.2 173.3,383.3  221.3,383.3 223.6,356.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122684751697781733670000011365841193263078529_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.3903,
    y1: -84.8641,
    x2: 228.708,
    y2: -84.8641,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000122684751697781733670000011365841193263078529_)"
    },
    points: "169.4,493.3 172.1,480.9  224.1,478.4 228.8,495.3  "
  }), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "174.2,381.8 171.5,359.2 221.7,357.4 220.7,364.8 219.8,360.1 175.6,370.9  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "226.5,494.7 222.7,480.7 172.9,482 170.6,492.8 172.3,489.7 221.8,482.7  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "177.6,388.8 214.7,420.1 214.7,478.8 217.3,478.6 218.5,383.3 177.6,383.3  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "177.1,355.3 177,347.2 218.9,347.2 218.9,350.1 178.9,349.2  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "151.5,779.8 161.4,496.2 233.3,501 237,549.3 229.8,506.8 164.7,557.9  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "221.5,495.1 237,779.8 148.2,784.6 249.2,783.5 231.5,495.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119831540676416592910000013526083895775451287_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.9757,
    y1: -328.8392,
    x2: 195.9757,
    y2: -91.0736,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "url(#SVGID_00000119831540676416592910000013526083895775451287_)",
      enableBackground: "new"
    },
    d: " M150.2,730.8c0,0,62-5.6,91.6-133.4l-5.6-101.6l-76.8-2.7L150.2,730.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075877019929392820770000008736047382372456578_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.7897,
    y1: -408.906,
    x2: 218.7242,
    y2: -340.3433,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075877019929392820770000008736047382372456578_)"
    },
    points: "137.9,787.5 144.5,757  258.5,762.5 262.4,787.5  "
  }), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "140,785.5 145.8,759.1 255.7,764.3 161.1,762.5 157.1,785.5  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "256.8,765.8 260.6,787.5 137.9,787.5 258.2,785.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178885210359716589710000009233182371521980085_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.1697,
    y1: -391.6112,
    x2: 356.1697,
    y2: 346.072,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000178885210359716589710000009233182371521980085_)"
    },
    points: "331.2,792.7 352.2,55.9  374.3,55.9 381.2,793.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116212324980062962240000000566833176603748023_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.3745,
    y1: 239.2694,
    x2: 375.6416,
    y2: 239.2694,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3E38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5992,
    style: {
      stopColor: "#A10C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#BA0C37"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000116212324980062962240000000566833176603748023_)"
    },
    points: "350.1,130.4 375.1,130.4  375.7,195 348.4,191.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093889360970543550910000005432156119282092971_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.8381,
    y1: 195.4645,
    x2: 375.7424,
    y2: 195.4645,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3E38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5992,
    style: {
      stopColor: "#A10C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#BA0C37"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000093889360970543550910000005432156119282092971_)"
    },
    points: "348,202.2 375.7,202.2  375.7,210.6 347.8,210.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147198695863788524600000018398026206932602241_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.746,
    y1: -387.9984,
    x2: 353.746,
    y2: 342.685,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFCE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000147198695863788524600000018398026206932602241_)",
      enableBackground: "new"
    },
    points: " 371.9,59.3 353.7,59.3 335.6,790 348.6,790 358.9,60.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102545248844634330800000002239428160700220339_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.9592,
    y1: 311.0515,
    x2: 366.7428,
    y2: 332.2154,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000102545248844634330800000002239428160700220339_)"
    },
    points: "345.7,74 347.8,86.9 376.9,86.9  379.6,76.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099656304756308233800000000836202440938711697_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.3836,
    y1: 322.2502,
    x2: 377.7964,
    y2: 322.2502,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000099656304756308233800000000836202440938711697_)",
      enableBackground: "new"
    },
    points: " 348.9,84.8 347.4,74.7 377.8,77.6 375.7,84.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168095530641504195140000011305570669380765365_",
    gradientUnits: "userSpaceOnUse",
    x1: 593.574,
    y1: -326.9659,
    x2: 758.0755,
    y2: -4.1136,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168095530641504195140000011305570669380765365_)"
    },
    d: "M747.3,493.1v0.9l-10,295.8h-24.4 c0-0.5,0-0.7,0-1.1l10-296c-0.2-51-28-92.6-62.4-92.6h-15.8c-30.6,0-55.4,37-55.4,82.6v34.8c0,10.2-5.5,18.3-12.3,18.3 c-6.7,0-12.3-8.1-12.3-18.3v-34.8c0-65.7,35.8-119,79.8-119h15.8C708.2,363.7,747.3,421.7,747.3,493.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173858989471823948120000011883173747603634314_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.6307,
    y1: -133.9539,
    x2: 673.8303,
    y2: 33.2599,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173858989471823948120000011883173747603634314_)"
    },
    d: "M574.8,522.2v-33 c0-62.1,33.8-112.4,75.4-112.4h15c21.2,0,40.6,12,55.1,31.8c-15-24.6-36.7-40.2-60.7-40.2h-15c-41.7,0-75.4,50.4-75.4,112.4v33 c0,7,2.7,12.9,6.7,15.6C575.2,527.2,574.8,524.7,574.8,522.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134955317475492999300000000611135772556350895_",
    gradientUnits: "userSpaceOnUse",
    x1: 644.2682,
    y1: -351.2464,
    x2: 788.0051,
    y2: -69.1465,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134955317475492999300000000611135772556350895_)"
    },
    d: "M732.5,501.4L722.6,790h-6.2 c0-0.5,0-0.9,0-1.4l10-296c0-23.3-5.9-44.5-15.5-60.7C724.1,448.8,732.3,473.7,732.5,501.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137822967721299417030000000717012346726144167_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.6331,
    y1: -222.4882,
    x2: 707.1575,
    y2: -222.4882,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7653,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000137822967721299417030000000717012346726144167_)"
    },
    points: "473.7,793.8 459.6,455.1  707.2,464.6 691.9,791.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121254114454103822530000000414851895360351381_",
    gradientUnits: "userSpaceOnUse",
    x1: 472.8122,
    y1: -381.5631,
    x2: 692.6151,
    y2: -381.5631,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3E38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5992,
    style: {
      stopColor: "#A10C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#BA0C37"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121254114454103822530000000414851895360351381_)"
    },
    points: "691.9,791.8 692.6,776.2  472.8,773.3 473.7,793.8  "
  }), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "459.6,455.1 461.6,501.2 705.8,496.7 707.2,464.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140728546841920938440000006703037836728756130_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.428,
    y1: -387.7726,
    x2: 571.428,
    y2: -60.5908,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000140728546841920938440000006703037836728756130_)",
      enableBackground: "new"
    },
    points: " 480.7,789.8 465.8,462.6 677,470.7 496,472.1 503.3,789.8  "
  }), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "684.3,470.7 675,787.3 508.4,789.8 687.3,789.8 702.9,470.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015342909916504321230000002962425850876394159_",
    gradientUnits: "userSpaceOnUse",
    x1: 514.6216,
    y1: -380.9986,
    x2: 514.6216,
    y2: -69.8485,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000015342909916504321230000002962425850876394159_)",
      enableBackground: "new"
    },
    points: " 508.4,472.3 513.3,783 520.8,781.4 517.7,471.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041266586591873516140000003706026248329256891_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.219,
    y1: -77.8644,
    x2: 461.0143,
    y2: -77.8644,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000041266586591873516140000003706026248329256891_)"
    },
    points: "454.2,471.6 461,488.1  461,484.5 456.6,471.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161594087914593111920000009561389269093090971_",
    gradientUnits: "userSpaceOnUse",
    x1: 706.0287,
    y1: -80.7998,
    x2: 713.1171,
    y2: -80.7998,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000161594087914593111920000009561389269093090971_)"
    },
    points: "711.6,475.2 706.1,487.9  706.1,490.4 713.1,475.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026862617658339060860000007329959372780267935_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.8958,
    y1: -93.1934,
    x2: 580.8958,
    y2: -71.4775,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000026862617658339060860000007329959372780267935_)"
    },
    points: "578.9,473.4 580.5,495.1  581.6,495.1 582.9,473.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013880225263775419120000002128182088494402177_",
    gradientUnits: "userSpaceOnUse",
    x1: 658.3798,
    y1: -93.985,
    x2: 658.3798,
    y2: -72.6049,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000013880225263775419120000002128182088494402177_)"
    },
    points: "658.8,474.6 654.6,496  655.7,496 662.2,474.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114787706886474422870000002822515557910434235_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.593,
    y1: -86.106,
    x2: 506.593,
    y2: -69.8783,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000114787706886474422870000002822515557910434235_)"
    },
    points: "503.3,471.8 508.6,488.1  509.9,488.1 506.6,472.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109027013417986374500000006958119141521416582_",
    gradientUnits: "userSpaceOnUse",
    x1: 552.9842,
    y1: -122.2817,
    x2: 609.6818,
    y2: -11.0064,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109027013417986374500000006958119141521416582_)"
    },
    points: "447.4,461.5 449.6,471.6  715.5,475.5 718.5,468.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062180529694330007890000013977031955641703582_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.3322,
    y1: -66.5745,
    x2: 687.0101,
    y2: -66.5745,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000062180529694330007890000013977031955641703582_)",
      enableBackground: "new"
    },
    points: " 449.3,463.3 450.4,470.7 685,473.9 687,468.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026125968784618650460000013162517275728619430_",
    gradientUnits: "userSpaceOnUse",
    x1: 562.4777,
    y1: -100.6673,
    x2: 610.7003,
    y2: -6.0253,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000026125968784618650460000013162517275728619430_)"
    },
    points: "470.1,455.6 474.3,447.2  695.2,451.1 698.4,464.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008135172261466090780000015588499247534418100_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.2407,
    y1: -84.6226,
    x2: 608.853,
    y2: -2.9538,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008135172261466090780000015588499247534418100_)"
    },
    points: "490.4,447.5 497.8,438.2  673.2,437.8 682.2,451.1  "
  }), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "494.8,447.7 500.1,439.8 673.2,437.8 519.9,441.1 517,447.7  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "472.7,455.1 475.4,448.6 694.1,452.4 496.6,451.1 494.8,455.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004511708566878886180000014201214480350121620_",
    gradientUnits: "userSpaceOnUse",
    x1: 721.7515,
    y1: -374.2587,
    x2: 728.6617,
    y2: -360.697,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000004511708566878886180000014201214480350121620_)"
    },
    points: "711.4,766.3 739.3,768.1  739.3,772.2 710.9,770.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053533852070737604090000000762610961602379164_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.674,
    y1: -196.6399,
    x2: 734.5841,
    y2: -183.0782,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000053533852070737604090000000762610961602379164_)"
    },
    points: "717.3,588.6 745.2,590.4  745.2,594.7 716.9,593.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057831147936807132750000008423795973838782342_",
    gradientUnits: "userSpaceOnUse",
    x1: 729.6254,
    y1: -137.926,
    x2: 736.8325,
    y2: -123.7813,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057831147936807132750000008423795973838782342_)"
    },
    points: "718.7,529.7 748.1,531.5  748.1,535.5 718.4,534.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034083878607356848370000012830032835236062603_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.1872,
    y1: -84.6869,
    x2: 739.5786,
    y2: -62.3299,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000034083878607356848370000012830032835236062603_)"
    },
    points: "720.6,478.2 748.1,468.7  748.2,470.7 720.3,482.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155114355287264869440000001869613717255237006_",
    gradientUnits: "userSpaceOnUse",
    x1: 723.1127,
    y1: -318.5623,
    x2: 730.6313,
    y2: -303.8064,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 712.2,
    y: 711.4,
    style: {
      fill: "url(#SVGID_00000155114355287264869440000001869613717255237006_)"
    },
    width: 29.4,
    height: 3.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062890764759552268320000010767024602690758579_",
    gradientUnits: "userSpaceOnUse",
    x1: 725.2431,
    y1: -260.5134,
    x2: 732.7617,
    y2: -245.7575,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 714.3,
    y: 653.4,
    style: {
      fill: "url(#SVGID_00000062890764759552268320000010767024602690758579_)"
    },
    width: 29.4,
    height: 3.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075157379170298468130000009241300576603399065_",
    gradientUnits: "userSpaceOnUse",
    x1: 714.8364,
    y1: -45.8797,
    x2: 731.657,
    y2: -12.8676,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075157379170298468130000009241300576603399065_)"
    },
    points: "712,446.3 735,419.5  733.2,415.6 710.9,444.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074415234866928877390000013884210037960255163_",
    gradientUnits: "userSpaceOnUse",
    x1: 686.8583,
    y1: -12.6754,
    x2: 706.0859,
    y2: 25.0608,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000074415234866928877390000013884210037960255163_)"
    },
    points: "705.8,376.8 690.3,416.5  688.8,414 702.3,375.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118398276344740130520000006448233747094409652_",
    gradientUnits: "userSpaceOnUse",
    x1: 646.7754,
    y1: 3.9335,
    x2: 663.6531,
    y2: 37.0583,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000118398276344740130520000006448233747094409652_)"
    },
    points: "654,361.7 654.9,402.3  656,402.3 657,361.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121990903982700688960000006308139245352735617_",
    gradientUnits: "userSpaceOnUse",
    x1: 611.9692,
    y1: 0.196,
    x2: 624.7421,
    y2: 25.2641,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121990903982700688960000006308139245352735617_)"
    },
    points: "627.9,406.8 610.7,369.6  608.8,371.6 625.4,408.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168797748802404144500000007364608853397967777_",
    gradientUnits: "userSpaceOnUse",
    x1: 586.2003,
    y1: -26.4263,
    x2: 588.3326,
    y2: -22.2413,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168797748802404144500000007364608853397967777_)"
    },
    points: "573.2,416.5 602.2,432.6  601.3,436.2 572.5,420.6  "
  }), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "721.4,534.4 745.8,535.5 745.6,538.2 721.4,535.5  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "719.4,593.3 743.8,594.5 743.7,598.3 719.3,596  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "717.2,659.3 741.5,662.9 741.7,657 717.3,657  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "715.3,715 715.2,718 739.6,720.5 739.7,715  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "713.4,770.8 713.4,774.4 737.6,776.2 737.6,772.2  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "722.3,481.8 746.1,471.6 746.5,476.6 722.6,484.3  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "713.5,444.5 732.9,421.9 734.9,426.7 714.4,446.3  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "691.7,412.7 693.5,414.3 707.2,384.2 704.1,381.3  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "656.1,400 657.9,400 659.3,363.7 657,363.7  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "624.1,405.9 610.4,375.2 607.8,377.2 623.1,406.6  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "599.3,435 575.8,422.4 574,427.1 598.4,437.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145015975110312579990000006102098785820389511_",
    gradientUnits: "userSpaceOnUse",
    x1: 558.1577,
    y1: -354.3972,
    x2: 696.7397,
    y2: -82.4148,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145015975110312579990000006102098785820389511_)"
    },
    d: "M639.4,741l-21.2-1.1l-0.2-23.3l22,0.9 L639.4,741z M640.2,715.3l-22.1-1.1l-0.2-23.3l22.9,0.9L640.2,715.3z M641.1,689.5l-23-1.1l-0.2-23.3l23.9,0.9L641.1,689.5z  M641.9,663.8l-23.9-1.1l-0.2-23.3l24.8,0.9L641.9,663.8z M642.6,638l-24.8-1.1l-0.2-23.3l25.8,0.9L642.6,638z M643.5,612.3 l-25.9-1.1l-0.2-23.3l26.7,0.9L643.5,612.3z M644.3,586.8l-26.8-1.1l-0.2-23.3l27.7,0.9L644.3,586.8z M645.2,561l-27.7-1.1 l-0.2-23.3l28.6,0.9L645.2,561z M646,535.3l-28.6-1.1l-0.2-23.3l29.5,0.9L646,535.3z M647.5,486.1l-0.8,23.5l-29.7-1.1l-0.2-22.4 H647.5z M618.4,765.6l-0.2-23.3l21.1,0.9l-0.8,23.5L618.4,765.6z M646.6,460.8l-2.1,5.6h3.6l-0.6,16.9h-30.6l-0.2-22.6l-4.4-0.2 l-2.1,5l3.8,0.5l2.6,320.2h1.8l-0.2-18.3l20.1,0.9l-0.6,17.6h1.7L650.8,461L646.6,460.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061437186487693988610000017982384661423902345_",
    gradientUnits: "userSpaceOnUse",
    x1: -1631.1172,
    y1: -343.9189,
    x2: -1508.6431,
    y2: -103.5497,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061437186487693988610000017982384661423902345_)"
    },
    d: "M196.8,570.3v0.7l7.4,220.2h18.2 c0-0.2,0-0.7,0-0.9L215,570.1c0.2-37.9,20.9-68.9,46.4-68.9h11.8c22.7,0,41.2,27.5,41.2,61.4v26c0,7.5,4.1,13.5,9.1,13.5 s9.1-6.1,9.1-13.5v-26c0-48.8-26.7-88.5-59.4-88.5h-11.8C225.7,473.9,196.8,517,196.8,570.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034053042769378344010000013273101455994409099_",
    gradientUnits: "userSpaceOnUse",
    x1: -1634.6519,
    y1: -199.9836,
    x2: -1571.3221,
    y2: -75.6918,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034053042769378344010000013273101455994409099_)"
    },
    d: "M325.1,591.7v-24.4 c0-46.1-25.1-83.5-56-83.5H258c-15.8,0-30.1,9-41.1,23.7c11.2-18.3,27.3-29.8,45.1-29.8h11.1c30.9,0,56,37.5,56,83.5v24.2 c0,5.2-2.1,9.7-5,11.5C324.8,595.6,325.1,593.8,325.1,591.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057855025011364282870000003151662584553085061_",
    gradientUnits: "userSpaceOnUse",
    x1: -1593.4181,
    y1: -361.5896,
    x2: -1486.5743,
    y2: -151.8969,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057855025011364282870000003151662584553085061_)"
    },
    d: "M207.9,576.4l7.3,214.5h4.7 c0-0.2,0-0.7,0-0.9l-7.4-220.2c0-17.2,4.4-33,11.5-45.2C214.1,537.3,207.9,555.8,207.9,576.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122696220871478342540000009888843272894167472_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.7039,
    y1: -265.8415,
    x2: 226.4996,
    y2: -265.8415,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7812,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000122696220871478342540000009888843272894167472_)"
    },
    points: "410.7,541.8 405.7,662.2  400.3,793.8 238,792.3 233.8,703.7 226.5,549.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156553203027195689220000014930565979865815697_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.6017,
    y1: -323.4201,
    x2: 318.6017,
    y2: -139.8461,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "url(#SVGID_00000156553203027195689220000014930565979865815697_)",
      enableBackground: "new"
    },
    d: " M410.7,541.8l-5,120.4c-23.6,38.4-62,63.2-105.1,63.2c-24.4,0-47.3-7.9-66.8-21.7l-7.3-154.7L410.7,541.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021095689706181740140000007942890520017685386_",
    gradientUnits: "userSpaceOnUse",
    x1: -1720.8383,
    y1: -384.1598,
    x2: -1557.3873,
    y2: -384.1598,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3E38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5992,
    style: {
      stopColor: "#A10C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#BA0C37"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000021095689706181740140000007942890520017685386_)"
    },
    points: "238,792.3 237.4,780.7  400.9,778.5 400.3,793.8  "
  }), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "410.7,541.8 409.3,576.2 227.7,572.8 226.5,549.1  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "243.6,553.4 250.4,788.9 374.5,790.7 241.3,790.7 229.7,553.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121974695445734525070000006469831672819481005_",
    gradientUnits: "userSpaceOnUse",
    x1: -1734.7233,
    y1: -158.3615,
    x2: -1729.6693,
    y2: -158.3615,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121974695445734525070000006469831672819481005_)"
    },
    points: "414.8,554.3 409.6,566.5  409.6,563.7 413,554.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151531519475689702780000016357352361568300949_",
    gradientUnits: "userSpaceOnUse",
    x1: -1547.4387,
    y1: -160.5065,
    x2: -1542.1667,
    y2: -160.5065,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000151531519475689702780000016357352361568300949_)"
    },
    points: "223.3,557 227.4,566.2  227.4,568 222.3,557  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145778393642108865220000008806593444263845515_",
    gradientUnits: "userSpaceOnUse",
    x1: -1640.5519,
    y1: -169.7356,
    x2: -1640.5519,
    y2: -153.5843,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145778393642108865220000008806593444263845515_)"
    },
    points: "322.1,555.6 320.7,571.7  320.1,571.7 319.1,555.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175313179065128169860000011283675022891270055_",
    gradientUnits: "userSpaceOnUse",
    x1: -1582.9124,
    y1: -170.3288,
    x2: -1582.9124,
    y2: -154.4272,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000175313179065128169860000011283675022891270055_)"
    },
    points: "262.6,556.5 265.7,572.3  265,572.3 260.1,556.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034054292413829848810000001053921469274705336_",
    gradientUnits: "userSpaceOnUse",
    x1: -1695.7677,
    y1: -164.4581,
    x2: -1695.7677,
    y2: -152.3887,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000034054292413829848810000001053921469274705336_)"
    },
    points: "378.3,554.5 374.3,566.5  373.3,566.5 375.9,554.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095328707139734734570000011124577048093511303_",
    gradientUnits: "userSpaceOnUse",
    x1: -1661.3628,
    y1: -191.3682,
    x2: -1619.1454,
    y2: -108.5115,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000095328707139734734570000011124577048093511303_)"
    },
    points: "419.9,546.6 418.1,554.3  220.4,557 218.2,551.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000919280769178717200000008064220538343891075_",
    gradientUnits: "userSpaceOnUse",
    x1: -1738.2589,
    y1: -150.0069,
    x2: -1561.6289,
    y2: -150.0069,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000000919280769178717200000008064220538343891075_)",
      enableBackground: "new"
    },
    points: " 418.3,548.2 417.5,553.4 243,555.8 241.6,552  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138559459537128893470000008516377566855457963_",
    gradientUnits: "userSpaceOnUse",
    x1: -1657.2699,
    y1: -369.0568,
    x2: -1554.1711,
    y2: -166.7139,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138559459537128893470000008516377566855457963_)"
    },
    d: "M271.6,551.1l1.5,3.6l-2.7,0.2l0.5,13.1 h22.7l0.2-16.9h3.3l1.5,3.6l-2.7,0.2l-2,238.2h-1.4v-13.5l-15,0.7l0.5,13.1h-1.2l-8.5-242.1L271.6,551.1z M276.9,759.5l15.8-0.9 l0.2-17.4l-16.4,0.7L276.9,759.5z M276.3,740.3l16.4-0.9l0.2-17.4l-17.1,0.7L276.3,740.3z M275.7,721.1l17.1-0.7l0.2-17.4 l-17.7,0.7L275.7,721.1z M275.1,701.9l17.9-0.7l0.2-17.4l-18.5,0.7L275.1,701.9z M274.5,683l18.5-0.9l0.2-17.4l-19.2,0.7 L274.5,683z M273.9,663.8l19.2-0.9l0.2-17.4l-19.8,0.7L273.9,663.8z M273.3,644.6l20-0.9l0.2-17.4l-20.6,0.7L273.3,644.6z  M272.7,625.6l20.6-0.9l0.2-17.4l-21.2,0.7L272.7,625.6z M272.1,606.4l21.4-0.9l0.2-17.4l-22,0.7L272.1,606.4z M270.9,569.8 l0.6,17.4l22-0.9l0.2-16.7h-22.7V569.8z M292.7,777.8l0.2-17.4l-15.6,0.7l0.6,17.6L292.7,777.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165228786327392540110000018028711422437328793_",
    gradientUnits: "userSpaceOnUse",
    x1: -1654.2439,
    y1: -175.3098,
    x2: -1618.3423,
    y2: -104.849,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000165228786327392540110000018028711422437328793_)"
    },
    points: "403,542.3 399.8,536  235.4,538.9 233.2,548.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125568444445261952230000003493221248509239984_",
    gradientUnits: "userSpaceOnUse",
    x1: -1650.6194,
    y1: -163.3415,
    x2: -1619.6593,
    y2: -102.579,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000125568444445261952230000003493221248509239984_)"
    },
    points: "387.8,536.2 382.4,529.4  251.8,529 245.1,538.9  "
  }), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "384.6,536.4 380.6,530.6 251.8,529 365.9,531.5 368,536.4  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "401,541.8 399,537.1 236.3,539.8 383.1,538.9 384.6,541.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155125266914347936940000003722314455056472212_",
    gradientUnits: "userSpaceOnUse",
    x1: -1535.7321,
    y1: -378.7636,
    x2: -1530.5906,
    y2: -368.6729,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000155125266914347936940000003722314455056472212_)"
    },
    points: "223.5,773.3 202.7,774.6  202.7,777.8 223.8,776.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144318981348859475370000013833414832587923864_",
    gradientUnits: "userSpaceOnUse",
    x1: -1531.3391,
    y1: -246.6716,
    x2: -1526.1974,
    y2: -236.5807,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000144318981348859475370000013833414832587923864_)"
    },
    points: "219.1,641.2 198.3,642.6  198.3,645.7 219.4,644.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172433433723369759200000017055240320540285318_",
    gradientUnits: "userSpaceOnUse",
    x1: -1529.8854,
    y1: -203.0225,
    x2: -1524.5234,
    y2: -192.4992,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000172433433723369759200000017055240320540285318_)"
    },
    points: "218,597.4 196.2,598.7  196.2,601.7 218.3,600.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175285141420430659250000017256653585819747221_",
    gradientUnits: "userSpaceOnUse",
    x1: -1530.9513,
    y1: -163.3966,
    x2: -1522.4803,
    y2: -146.7711,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000175285141420430659250000017256653585819747221_)"
    },
    points: "216.5,559 196.2,552  196.1,553.4 216.8,562.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049901379449382362430000017193083799017866142_",
    gradientUnits: "userSpaceOnUse",
    x1: -1534.6332,
    y1: -337.4384,
    x2: -1529.037,
    y2: -326.4554,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 200.9,
    y: 732.6,
    style: {
      fill: "url(#SVGID_00000049901379449382362430000017193083799017866142_)"
    },
    width: 22,
    height: 2.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060714718289117353460000016319469890910925462_",
    gradientUnits: "userSpaceOnUse",
    x1: -1533.1534,
    y1: -294.1541,
    x2: -1527.5574,
    y2: -283.171,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.4,
    y: 689.3,
    style: {
      fill: "url(#SVGID_00000060714718289117353460000016319469890910925462_)"
    },
    width: 22,
    height: 2.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069373600109356514880000017015494294519778466_",
    gradientUnits: "userSpaceOnUse",
    x1: -1540.871,
    y1: -134.5686,
    x2: -1528.3507,
    y2: -109.9959,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000069373600109356514880000017015494294519778466_)"
    },
    points: "223,535.5 205.9,515.4  207.3,512.5 223.8,533.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061473742037992749960000003725217730725991566_",
    gradientUnits: "userSpaceOnUse",
    x1: -1561.7924,
    y1: -109.7764,
    x2: -1547.6665,
    y2: -82.0529,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000061473742037992749960000003725217730725991566_)"
    },
    points: "228,484.7 239.2,513.2  240.3,511.4 230.3,482.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002364959959534223430000010607543805950092673_",
    gradientUnits: "userSpaceOnUse",
    x1: -1591.5553,
    y1: -97.486,
    x2: -1578.9856,
    y2: -72.8164,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000002364959959534223430000010607543805950092673_)"
    },
    points: "266.2,472.3 265.4,502.6  264.7,502.6 263.9,472.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134934895018377176190000012078420266820961722_",
    gradientUnits: "userSpaceOnUse",
    x1: -1617.476,
    y1: -100.2624,
    x2: -1607.9653,
    y2: -81.597,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134934895018377176190000012078420266820961722_)"
    },
    points: "285.6,505.9 298.3,478.4  299.8,479.8 287.4,507.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036971598243899866780000005712521889475362988_",
    gradientUnits: "userSpaceOnUse",
    x1: -1636.6194,
    y1: -120.155,
    x2: -1634.9669,
    y2: -116.9119,
    gradientTransform: "matrix(-1 0 0 -1 -1319.981 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C5A69D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#6F617A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C2929D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000036971598243899866780000005712521889475362988_)"
    },
    points: "326.2,513.2 304.7,525.1  305.4,527.8 326.8,516.1  "
  }), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "216,600.8 197.9,601.7 198,603.7 216,601.7  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "217.6,644.6 199.4,645.7 199.4,648.4 217.6,646.6  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "219.2,693.6 201.1,696.5 200.9,692 219.1,692  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "220.6,735.1 220.6,737.4 202.6,739.4 202.4,735.1  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "222,776.9 222,779.4 203.9,780.7 203.9,777.8  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "215.3,561.7 197.7,554.3 197.3,557.9 215.1,563.7  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "221.8,533.9 207.4,517.2 206,520.8 221.2,535.5  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "238,510.5 236.8,511.6 226.5,489.2 228.9,487  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "264.7,501 263.2,501 262.2,473.9 263.9,473.9  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "288.3,505.3 298.6,482.5 300.6,484 289.1,505.7  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "306.8,527.2 324.4,517.5 325.6,521.1 307.5,528.5  "
  }))), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "474.3,772.2 477.5,793.8 372.8,793.8 475.2,791.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047780214343309210840000003811422279395200933_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.1286,
    y1: 17.7612,
    x2: 472.8776,
    y2: 17.7612,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047780214343309210840000003811422279395200933_)"
    },
    points: "408.1,371.6 410.9,395.8  411.3,395.8 409.9,374.8 424.3,374.8 424.2,374.8 425.4,396 426,396 426,374.8 454.3,374.5 454.3,396.7 454.9,396.7 456.1,374.5  455.2,374.5 471.8,374.3 469,396.9 469.6,396.9 472.8,371.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175289630420158081090000004549323379699109300_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.5524,
    y1: 110.5643,
    x2: 470.1235,
    y2: 110.5643,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000175289630420158081090000004549323379699109300_)"
    },
    points: "410.6,278.8 413.1,303  413.6,303 412.2,282 425.5,282 425.4,282 426.5,303.2 427.1,303.2 427.1,282 453.1,281.7 453.1,303.9 453.6,303.9 454.8,281.7  454,281.7 469.2,281.5 466.8,304.1 467.4,304.1 470.2,278.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097484841758696463460000009030387086776345754_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.9118,
    y1: 206.5286,
    x2: 467.7194,
    y2: 206.5286,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000097484841758696463460000009030387086776345754_)"
    },
    points: "413,182.8 415.2,207 415.6,207  414.5,186 426.6,186 426.5,186 427.5,207.2 428,207.2 428,186 452.1,185.8 452.1,207.9 452.5,207.9 453.6,185.8 452.8,185.8  466.8,185.5 464.5,208.1 465.1,208.1 467.7,182.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157292727577627806140000005206053419562826117_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.9782,
    y1: -82.3803,
    x2: 478.4171,
    y2: -82.3803,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000157292727577627806140000005206053419562826117_)"
    },
    points: "403,471.6 406.2,495.8  406.6,495.8 404.9,475 421.8,474.8 421.6,474.8 423,496.2 423.7,496.2 423.7,474.8 456.8,474.6 456.8,496.9 457.4,496.9  458.9,474.6 457.8,474.6 477.1,474.6 474,497.1 474.6,497.1 478.4,471.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147934703681844455810000017079298098006615208_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.2072,
    y1: -48.9622,
    x2: 498.8673,
    y2: -48.9622,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000147934703681844455810000017079298098006615208_)"
    },
    points: "467.5,110.1 467.7,108.1  498.9,793.8 491.7,793.8 467.2,114.6 467.2,113.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167356791764016318140000005664009855033380000_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.9188,
    y1: -199.7955,
    x2: 484.7794,
    y2: -199.7955,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000167356791764016318140000005664009855033380000_)"
    },
    points: "396.9,589 400.7,613.2  401.2,613.2 399.3,592.2 418.9,592.2 418.7,592.2 420.2,613.4 421.2,613.4 421.2,592.2 459.6,592 459.6,614.1 460.4,614.1  462.1,592 460.8,592 483.4,592 479.6,614.6 480.5,614.6 484.8,589  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160909007004221554480000016824900744841414826_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.1828,
    y1: -391.8369,
    x2: 439.1828,
    y2: 258.4622,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4AC88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4EDA1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000160909007004221554480000016824900744841414826_)"
    },
    points: "483.9,793.8 394.5,793.8  408,464.6 421.2,143.5 456.5,143.5 465.2,351.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112599137530215293690000017734484277532519811_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.1552,
    y1: -387.7726,
    x2: 426.1552,
    y2: 254.6236,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000112599137530215293690000017734484277532519811_)",
      enableBackground: "new"
    },
    points: " 397.5,789.8 424.2,147.4 454.8,147.4 429.9,152.1 421.9,789.8  "
  }), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "394.5,793.8 471.3,788.9 450.8,147.4 454.8,147.4 478.1,793.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151542874867601921240000002654178666357831596_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.2275,
    y1: -57.3261,
    x2: 412.68,
    y2: 257.4241,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.21,
      fill: "url(#SVGID_00000151542874867601921240000002654178666357831596_)",
      enableBackground: "new"
    },
    d: " M465.2,351.3c-16.7,46.1-35.9,84.9-57.3,113.4l13.2-321.1h35.3L465.2,351.3z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M394.5,793.8c0,0,79.4-27.5,79.4-236.6l10,236.6H394.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163032293299205846430000012885670702270620843_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.9269,
    y1: -389.8047,
    x2: 430.9269,
    y2: 251.0109,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9CFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000163032293299205846430000012885670702270620843_)",
      enableBackground: "new"
    },
    points: " 433.7,151 426.2,791.8 433.7,791.8 435.7,151  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007389185336403309240000007252390379387129780_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.7689,
    y1: -411.3066,
    x2: 455.0157,
    y2: -349.9813,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000007389185336403309240000007252390379387129780_)"
    },
    points: "385.6,793.8 391.2,763.4  488.4,769 491.7,793.8  "
  }), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "387.2,791.8 392.2,765.4 486.1,770.6 405.3,768.8 401.9,791.8  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "401.5,624.3 401.2,631.3 477.4,641 476.8,624.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008120295080065599580000007623375989809238934_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.4596,
    y1: -238.3177,
    x2: 449.3702,
    y2: -193.3533,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008120295080065599580000007623375989809238934_)"
    },
    points: "391.8,613 394.9,624.3  483.3,624.3 487.1,614.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183971779408315266090000008393850089118197426_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.5862,
    y1: -217.069,
    x2: 477.4628,
    y2: -217.069,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000183971779408315266090000008393850089118197426_)",
      enableBackground: "new"
    },
    points: " 393.6,614.8 477.4,616.4 475.4,622 395.9,623.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019642482794343662150000007265761640685844404_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.2535,
    y1: -198.102,
    x2: 488.718,
    y2: -198.102,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000019642482794343662150000007265761640685844404_)"
    },
    points: "390.3,585.9 394.3,613  395.9,613 393,589.5 414.8,589.5 414.6,589.5 416.5,613.4 417.4,613.4 417.4,589.5 460.5,589.3 460.5,614.1 461.5,614.1  463.3,589.3 461.9,589.3 487.1,589 483,614.3 484,614.3 488.7,585.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127750716464452761950000016469425638488045224_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.7331,
    y1: -214.2834,
    x2: 481.1276,
    y2: -184.0701,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127750716464452761950000016469425638488045224_)"
    },
    points: "463.3,589.3 461.5,614.1  461.8,614.1 463.7,589.7 486.6,589.7 483,614.3 487.1,589  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080909114445004954720000011142441619681142937_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.8127,
    y1: -215.1335,
    x2: 443.4637,
    y2: -178.5287,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000080909114445004954720000011142441619681142937_)"
    },
    points: "417.4,613.4 417.4,589.5  460.5,589.3 418.1,589.9 417.8,613.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122697882142948949000000011174534575051652772_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.673,
    y1: -209.3495,
    x2: 406.0837,
    y2: -183.0297,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000122697882142948949000000011174534575051652772_)"
    },
    points: "395.9,613 393,589.5  414.6,589.5 393.9,590.2 396,613  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031179944157558875180000004253154849744556702_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.8595,
    y1: -197.4246,
    x2: 480.5378,
    y2: -197.4246,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000031179944157558875180000004253154849744556702_)",
      enableBackground: "new"
    },
    points: " 394.9,612.5 390.9,587 480.5,586.3 479.5,587.9 392.8,589.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142137198476659792190000003565614633950010548_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.9514,
    y1: -118.4208,
    x2: 448.1767,
    y2: -78.7263,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000142137198476659792190000003565614633950010548_)"
    },
    points: "398.4,495.6 401.3,506.8  477.1,506.8 480.4,497.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013915981776682888220000010093022144383614872_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.1,
    y1: -99.7668,
    x2: 472.0547,
    y2: -99.7668,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000013915981776682888220000010093022144383614872_)",
      enableBackground: "new"
    },
    points: " 400.1,497.6 472.1,498.9 470.4,504.6 402.1,505.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126288595815221873430000005178505019845280390_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.2218,
    y1: -80.7998,
    x2: 481.7497,
    y2: -80.7998,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000126288595815221873430000005178505019845280390_)"
    },
    points: "397.2,468.5 400.9,495.6  402.1,495.6 399.5,472.1 418.3,472.1 418.1,472.1 419.8,496 420.6,496 420.6,472.1 457.5,471.8 457.5,496.7 458.3,496.7  459.9,471.8 458.7,471.8 480.4,471.8 476.8,497.1 477.7,497.1 481.7,468.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124121216283656202460000013006662333737996424_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.3349,
    y1: -96.2482,
    x2: 475.9405,
    y2: -67.5832,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000124121216283656202460000013006662333737996424_)"
    },
    points: "459.9,471.8 458.3,496.7  458.6,496.7 460.2,472.3 479.8,472.3 476.8,497.1 480.4,471.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160909714867788954930000004856256089030379656_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.4948,
    y1: -96.5283,
    x2: 442.886,
    y2: -62.3961,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000160909714867788954930000004856256089030379656_)"
    },
    points: "420.6,496 420.6,472.1  457.5,471.8 421.2,472.5 420.9,496  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124869273981703701040000005896099136868164003_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.8835,
    y1: -91.5192,
    x2: 410.7478,
    y2: -66.2719,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000124869273981703701040000005896099136868164003_)"
    },
    points: "402.1,495.6 399.5,472.1  418.1,472.1 400.3,472.8 402.2,495.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013889003641638549510000011980581740912891325_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.8277,
    y1: -80.0095,
    x2: 474.6299,
    y2: -80.0095,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000013889003641638549510000011980581740912891325_)",
      enableBackground: "new"
    },
    points: " 401.3,495.1 397.8,469.6 474.6,468.9 473.9,470.5 399.5,471.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069355544935652854020000003519066933569578112_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.2331,
    y1: -16.2097,
    x2: 447.1848,
    y2: 19.0227,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000069355544935652854020000003519066933569578112_)"
    },
    points: "404.3,395.3 406.8,406.8  471.6,406.8 474.5,396.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088853887322690113740000011402056922050249116_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.6311,
    y1: 0.4876,
    x2: 467.3889,
    y2: 0.4876,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000088853887322690113740000011402056922050249116_)",
      enableBackground: "new"
    },
    points: " 405.7,397.3 467.4,398.9 466,404.3 407.4,405.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112631512919524123270000006520725408062349205_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.1297,
    y1: 19.3418,
    x2: 475.6904,
    y2: 19.3418,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000112631512919524123270000006520725408062349205_)"
    },
    points: "403.1,368.4 406.3,395.5  407.4,395.5 405.3,372 421.3,371.8 421.2,371.8 422.5,395.8 423.1,395.8 423.1,371.8 454.9,371.6 454.9,396.4 455.5,396.4  457.1,371.6 456,371.6 474.5,371.6 471.4,396.9 472.2,396.9 475.7,368.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134934075542436731750000013635248031898238609_",
    gradientUnits: "userSpaceOnUse",
    x1: 457.5259,
    y1: 4.5578,
    x2: 471.5029,
    y2: 31.9894,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134934075542436731750000013635248031898238609_)"
    },
    points: "457.1,371.6 455.5,396.4  455.8,396.4 457.4,372.3 474.2,372 471.4,396.9 474.5,371.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177473135037746204300000003624828943584379275_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.0255,
    y1: 4.7679,
    x2: 442.3273,
    y2: 36.7617,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000177473135037746204300000003624828943584379275_)"
    },
    points: "423.1,395.8 423.1,371.8  454.9,371.6 423.7,372.5 423.4,395.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145762263849311108360000006562456558786058392_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.4732,
    y1: 9.0081,
    x2: 414.8735,
    y2: 33.3452,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145762263849311108360000006562456558786058392_)"
    },
    points: "407.4,395.5 405.3,372  421.2,371.8 405.9,372.5 407.5,395.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131329399267015663750000003083314828490153150_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.7356,
    y1: 20.0192,
    x2: 469.6996,
    y2: 20.0192,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000131329399267015663750000003083314828490153150_)",
      enableBackground: "new"
    },
    points: " 406.8,395.1 403.7,369.3 469.6,368.9 469,370.5 405.1,371.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009579094209136975560000010040002174025102493_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.8345,
    y1: 77.6251,
    x2: 446.6666,
    y2: 110.6599,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000009579094209136975560000010040002174025102493_)"
    },
    points: "407.1,302.5 409.3,314 469,314  471.8,304.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073680292851738726470000009253150051530545041_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.2801,
    y1: 93.2907,
    x2: 465.0865,
    y2: 93.2907,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000073680292851738726470000009253150051530545041_)",
      enableBackground: "new"
    },
    points: " 408.3,304.5 465.1,306.1 463.9,311.5 409.9,312.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017494777351207405370000009115639993429284251_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.0865,
    y1: 112.1449,
    x2: 472.8445,
    y2: 112.1449,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000017494777351207405370000009115639993429284251_)"
    },
    points: "406.2,275.6 408.9,302.7  409.9,302.7 408,279.2 422.8,279 422.7,279 423.9,303 424.5,303 424.5,279 453.7,278.8 453.7,303.6 454.3,303.6 455.5,278.8  454.6,278.8 471.8,278.8 469,304.1 469.6,304.1 472.8,275.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086688470524302792750000007211617288811391889_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.6832,
    y1: 97.6093,
    x2: 469.3482,
    y2: 124.4285,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000086688470524302792750000007211617288811391889_)"
    },
    points: "455.5,278.8 454.3,303.6  454.6,303.6 455.8,279.2 471.3,279.2 469,304.1 471.8,278.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018940535888925902680000013590159208899905677_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.3667,
    y1: 98.0918,
    x2: 442.1459,
    y2: 129.0602,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000018940535888925902680000013590159208899905677_)"
    },
    points: "424.5,303 424.5,279  453.7,278.8 425.1,279.5 424.8,303  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165920827945431408360000003168798923449503661_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.6873,
    y1: 101.9947,
    x2: 416.8558,
    y2: 125.8764,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000165920827945431408360000003168798923449503661_)"
    },
    points: "409.9,302.7 408,279.2  422.7,279 408.6,279.7 410.1,302.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132769651061803134050000002666091179988358046_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.6138,
    y1: 112.8223,
    x2: 467.3029,
    y2: 112.8223,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000132769651061803134050000002666091179988358046_)",
      enableBackground: "new"
    },
    points: " 409.3,302.3 406.6,276.5 467.2,276.1 466.6,277.7 408,278.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069377877902393568000000007933490118319648438_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.4494,
    y1: 174.4989,
    x2: 446.2534,
    y2: 205.5159,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000069377877902393568000000007933490118319648438_)"
    },
    points: "409.6,206.5 411.8,218.1  466.8,218.1 469.2,208.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029039581615865866940000015480137471165744282_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.8553,
    y1: 189.255,
    x2: 463.1172,
    y2: 189.255,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000029039581615865866940000015480137471165744282_)",
      enableBackground: "new"
    },
    points: " 410.9,208.6 463.1,210.1 461.9,215.6 412.2,216.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042703788873807221700000011139769396850081939_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.7345,
    y1: 208.1092,
    x2: 470.1541,
    y2: 208.1092,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000042703788873807221700000011139769396850081939_)"
    },
    points: "408.7,179.7 411.5,206.8  412.2,206.8 410.4,183.3 424.2,183.1 424,183.1 425.1,207 425.7,207 425.7,183.1 452.7,182.8 452.7,207.7 453.1,207.7  454.3,182.8 453.4,182.8 469.2,182.8 466.6,208.1 467.2,208.1 470.2,179.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154410923593135405820000003266885439455441031_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.995,
    y1: 193.8281,
    x2: 467.3711,
    y2: 220.08,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000154410923593135405820000003266885439455441031_)"
    },
    points: "454.3,182.8 453.1,207.7  453.4,207.7 454.6,183.5 468.7,183.3 466.6,208.1 469.2,182.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110448916415017419120000015891923916369283510_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.6766,
    y1: 194.5157,
    x2: 441.9697,
    y2: 224.53,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000110448916415017419120000015891923916369283510_)"
    },
    points: "425.7,207 425.7,183.1  452.7,182.8 426.2,183.7 426,207  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106863113041534534170000009622809286454489522_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.848,
    y1: 198.0749,
    x2: 418.798,
    y2: 221.5277,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000106863113041534534170000009622809286454489522_)"
    },
    points: "412.2,206.8 410.4,183.3  424,183.1 411,183.7 412.4,206.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069357031440946965590000018310226738404954275_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.189,
    y1: 208.7866,
    x2: 465.0251,
    y2: 208.7866,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000069357031440946965590000018310226738404954275_)",
      enableBackground: "new"
    },
    points: " 411.8,206.3 409.2,180.6 465.1,180.1 464.5,181.7 410.4,182.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139257933116212204440000010047906016913656968_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.0354,
    y1: 279.2357,
    x2: 465.4602,
    y2: 279.2357,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000139257933116212204440000010047906016913656968_)"
    },
    points: "415.1,111 417.2,133.4  417.5,133.4 416.5,114 427.7,114 427.5,114 428.4,133.6 428.9,133.6 428.9,114 451,113.7 451,134.3 451.5,134.3 452.4,113.7  451.8,113.7 464.6,113.7 462.5,134.5 463,134.5 465.4,111  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029024388956545110550000005026773265116932798_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.1319,
    y1: 249.7516,
    x2: 445.6507,
    y2: 278.2462,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000029024388956545110550000005026773265116932798_)"
    },
    points: "412.1,132.9 414,143.5  464.5,143.5 466.8,134.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066515437298845084440000014419686036883505057_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.1276,
    y1: 263.3169,
    x2: 461.223,
    y2: 263.3169,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000066515437298845084440000014419686036883505057_)",
      enableBackground: "new"
    },
    points: " 413.1,134.7 461.1,136.3 460.1,141.3 414.5,142.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096781588726425915280000002401549645914951863_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.1583,
    y1: 280.7033,
    x2: 467.6617,
    y2: 280.7033,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096781588726425915280000002401549645914951863_)"
    },
    points: "411.2,108.1 413.6,133.2  414.5,133.2 412.8,111.5 425.4,111.5 425.2,111.5 426.3,133.4 426.8,133.4 426.8,111.5 451.6,111.2 451.6,134.1 452.1,134.1  453.1,111.2 452.4,111.2 466.8,111.2 464.5,134.5 464.9,134.5 467.7,108.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116931207989986511100000001123913320813436549_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.8893,
    y1: 267.5226,
    x2: 465.1992,
    y2: 291.6819,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000116931207989986511100000001123913320813436549_)"
    },
    points: "453.1,111.2 452.1,134.1  452.2,134.1 453.4,111.7 466.4,111.7 464.5,134.5 466.8,111.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157289568461897790860000009179305393054276228_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.7172,
    y1: 268.136,
    x2: 441.7887,
    y2: 295.7528,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000157289568461897790860000009179305393054276228_)"
    },
    points: "426.8,133.4 426.8,111.5  451.6,111.2 427.2,111.9 427.1,133.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031194129854890204720000018356799180988651179_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.5054,
    y1: 271.3892,
    x2: 420.5032,
    y2: 292.9734,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031194129854890204720000018356799180988651179_)"
    },
    points: "414.5,133.2 412.8,111.5  425.2,111.5 413.3,111.9 414.6,133.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024697022040264802890000006336650822650910081_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.6128,
    y1: 281.3807,
    x2: 462.9657,
    y2: 281.3807,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000024697022040264802890000006336650822650910081_)",
      enableBackground: "new"
    },
    points: " 414,132.7 411.6,109.2 463,108.5 462.5,110.1 412.8,111.2  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "471.8,506.8 406.3,506.8 406,512.5 472.5,524  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "410.4,406.8 467.5,406.8 468.1,419.2 410.2,409.1  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "414.2,314 414,318.8 464.2,326.7 463.7,314  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "459.6,218.1 418.1,218.1 418,222.3 460.1,228  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "421.2,143.5 420.7,156.2 457.4,163.2 456.5,143.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111903026388251674630000014331771290361833879_",
    gradientUnits: "userSpaceOnUse",
    x1: 927.5663,
    y1: -252.2936,
    x2: 1126.616,
    y2: -252.2936,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D11D37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7052"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111903026388251674630000014331771290361833879_)"
    },
    points: "927.6,685.2 949.5,621.3  1104,621.3 1126.6,687.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085245043951256996180000002978486523611932569_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.6678,
    y1: -288.8729,
    x2: 1178.8778,
    y2: -288.8729,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7653,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085245043951256996180000002978486523611932569_)"
    },
    points: "1177.4,697 878,697  876.7,684.8 1178.9,687.7  "
  }), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "878,685.9 939.8,685.9 940.7,695.6 879.1,695.6  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "941.8,685.9 948.5,685.9 949.5,695.6 942.4,695.6  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "1159.5,688.6 1158,695.2 1177.4,695.2 1178.6,688.8  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127011893480778287150000009465110496323184302_",
    cx: 614.0921,
    cy: -259.3127,
    r: 164.0511,
    gradientTransform: "matrix(1.2499 0 0 -1.4906 139.5696 312.6384)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127011893480778287150000009465110496323184302_)"
    },
    points: "884.7,697 895,722 1152.1,722  1161.9,697  "
  }), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "1156,711.6 888.8,706.9 884.7,697 1161.9,697  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "891.2,709.4 945.7,711.6 949.5,720.5 895,720.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168811718814151471950000004070156581929417135_",
    gradientUnits: "userSpaceOnUse",
    x1: 912.9481,
    y1: -389.4789,
    x2: 912.9481,
    y2: -319.9331,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168811718814151471950000004070156581929417135_)"
    },
    points: "905.4,722 916.5,791.6  920.4,791.6 915.3,722  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140698891132984272020000010763094779610521244_",
    gradientUnits: "userSpaceOnUse",
    x1: 1132.6753,
    y1: -390.7079,
    x2: 1132.6753,
    y2: -320.0331,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000140698891132984272020000010763094779610521244_)"
    },
    points: "1140.1,722 1128.7,792.7  1125.3,792.7 1132.7,722  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172431952628121676860000008044831612543303858_",
    gradientUnits: "userSpaceOnUse",
    x1: 974.2233,
    y1: -389.5789,
    x2: 974.2233,
    y2: -320.0331,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000172431952628121676860000008044831612543303858_)"
    },
    points: "925.1,791.6 1010.7,722  1023.3,722 930.4,791.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046299847226528662680000018375235797269045405_",
    gradientUnits: "userSpaceOnUse",
    x1: 1075.0358,
    y1: -390.614,
    x2: 1075.0358,
    y2: -319.9391,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000046299847226528662680000018375235797269045405_)"
    },
    points: "1027.7,722 1041.5,722  1122.4,792.7 1117.1,792.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083064595925464536120000015714688440930989212_",
    gradientUnits: "userSpaceOnUse",
    x1: 1025.652,
    y1: -390.0306,
    x2: 1025.652,
    y2: -319.8931,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000083064595925464536120000015714688440930989212_)"
    },
    points: "1020.9,722 1024.5,792  1027.7,792 1030.4,722  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018224098475445265440000017490126907966071463_",
    gradientUnits: "userSpaceOnUse",
    x1: 969.906,
    y1: -390.0306,
    x2: 969.906,
    y2: -319.9105,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000018224098475445265440000017490126907966071463_)"
    },
    points: "915.3,722 1024.5,792  1024.4,788.6 925.1,722  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173121617934118101760000014306656093704878494_",
    gradientUnits: "userSpaceOnUse",
    x1: 1080.1862,
    y1: -390.0306,
    x2: 1080.1862,
    y2: -318.2951,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000173121617934118101760000014306656093704878494_)"
    },
    points: "1132.7,722 1027.7,792  1027.8,788.6 1125.3,720.5  "
  }), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "907.1,724.3 909.4,724.3 918.5,791.6 916.8,790.9  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "1011.9,724.3 927.6,791.6 1014.7,724.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056399155191641468610000010787818166076527032_",
    gradientUnits: "userSpaceOnUse",
    x1: 640.9919,
    y1: -220.2302,
    x2: 779.2773,
    y2: -220.2302,
    gradientTransform: "matrix(1.2499 0 0 -1 139.5696 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459459,
    style: {
      stopColor: "#C0C9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7653,
    style: {
      stopColor: "#8B9AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD6C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000056399155191641468610000010787818166076527032_)"
    },
    points: "940.7,632.8 945.7,611.6  1108,614.8 1113.6,632.8  "
  }), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "943.6,631 948.6,613.6 980.3,614.8 977.3,631  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "1083.4,616.1 1086,631 941,631.7 940.7,632.8 1110,632.8 1105.4,616.1  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "943.2,639.8 1087.8,646.8 1116.3,657.2 1108,632.8 945.6,632.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104680158360839169720000017657319649884583296_",
    gradientUnits: "userSpaceOnUse",
    x1: 962.7863,
    y1: -267.273,
    x2: 962.7863,
    y2: -246.2217,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 955.6,
    y: 648.2,
    style: {
      fill: "url(#SVGID_00000104680158360839169720000017657319649884583296_)"
    },
    width: 14.4,
    height: 21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158722050983751544900000011123845800564946826_",
    gradientUnits: "userSpaceOnUse",
    x1: 1091.699,
    y1: -267.273,
    x2: 1091.699,
    y2: -246.2217,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1084.5,
    y: 648.2,
    style: {
      fill: "url(#SVGID_00000158722050983751544900000011123845800564946826_)"
    },
    width: 14.4,
    height: 21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144302632257266881280000013466371764368444598_",
    gradientUnits: "userSpaceOnUse",
    x1: 1026.5609,
    y1: -211.4241,
    x2: 1026.5609,
    y2: 121.8542,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#755E75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D1D31"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000144302632257266881280000013466371764368444598_)"
    },
    points: "1016.8,613 1024.4,281.3  1033,280.1 1036.3,613.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099621813813999010530000008255934964536275328_",
    gradientUnits: "userSpaceOnUse",
    x1: 1016.7902,
    y1: 94.4197,
    x2: 1041.785,
    y2: 94.4197,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000099621813813999010530000008255934964536275328_)"
    },
    points: "1020.9,288.3 1016.8,326.9  1041.8,326.9 1037.7,288.3  "
  }), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "1018,326 1021.8,289.2 1026,289.2 1024.7,325.1  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "1022.8,348.1 1033.8,356.7 1033.5,326.9 1023.3,326.9  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "1017.7,608.2 1023.9,350.6 1026.5,353.3 1024.5,608.2  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000176020967498489512710000016626417711597606571_",
    cx: 722.978,
    cy: -26.9824,
    r: 144.2378,
    gradientTransform: "matrix(1.2499 0 0 -1.4906 139.5696 312.6384)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#14133E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B6A89"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000176020967498489512710000016626417711597606571_)"
    },
    points: "1041.8,326.9 1091.8,614.3  1090,614.3 1038.9,326.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000143605853296076486990000004192016579700781444_",
    cx: 662.3099,
    cy: -26.8328,
    r: 143.5784,
    gradientTransform: "matrix(1.2499 0 0 -1.4906 139.5696 312.6384)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#14133E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B6A89"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000143605853296076486990000004192016579700781444_)"
    },
    points: "1016.8,326.9 962.9,611.8  963.8,611.8 1019.5,326.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054962744100690634350000013754462043108777865_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.7225,
    y1: -330.4198,
    x2: 680.1934,
    y2: -330.4198,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D11D37"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000054962744100690634350000013754462043108777865_)"
    },
    points: "320.7,685.9 322.1,775.8  676.6,778.9 680.2,685.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031926414197096152410000005594942114024255421_",
    gradientUnits: "userSpaceOnUse",
    x1: 553.25,
    y1: -319.3126,
    x2: 553.25,
    y2: -295.3036,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 548.1,
    y: 697.2,
    style: {
      fill: "url(#SVGID_00000031926414197096152410000005594942114024255421_)"
    },
    width: 10.3,
    height: 23.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158714937307513186390000014842929697268396981_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.4227,
    y1: -276.9056,
    x2: 693.6754,
    y2: -276.9056,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00198413,
    style: {
      stopColor: "#BA0C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    style: {
      stopColor: "#A10C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF3E38"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000158714937307513186390000014842929697268396981_)"
    },
    points: "691.9,685.9 307.4,685.9  305.4,671.9 693.7,675.3  "
  }), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "307.4,673.3 386.6,673.3 387.8,684.3 308.6,684.3  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "389.2,673.3 397.7,673.3 399.2,684.3 390.1,684.3  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "668.8,676.4 667,683.9 691.9,683.9 693.4,676.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136397523069680231480000007462661793626417566_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.3828,
    y1: -319.3126,
    x2: 643.3828,
    y2: -295.3036,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 638.2,
    y: 697.2,
    style: {
      fill: "url(#SVGID_00000136397523069680231480000007462661793626417566_)"
    },
    width: 10.3,
    height: 23.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086659804872971836710000011728920755788575881_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.9047,
    y1: -330.4198,
    x2: 680.1934,
    y2: -330.4198,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00198413,
    style: {
      stopColor: "#BA0C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    style: {
      stopColor: "#A10C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF3E38"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000086659804872971836710000011728920755788575881_)"
    },
    points: "678.5,739.4 320.7,739.4  318.9,725.4 680.2,728.8  "
  }), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "320.7,726.8 394.5,726.8 395.6,737.8 321.8,737.8  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "396.9,726.8 404.8,726.8 406.2,737.8 397.7,737.8  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "657,729.7 655.4,737.4 678.5,737.4 679.9,730.2  "
  }))), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st184",
    points: "320.7,694.3 679.6,702.6 680.2,685.9 320.7,685.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011001469122502790970000005386655565966174906_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.356,
    y1: -319.3126,
    x2: 334.356,
    y2: -295.3036,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 329.2,
    y: 697.2,
    style: {
      fill: "url(#SVGID_00000011001469122502790970000005386655565966174906_)"
    },
    width: 10.3,
    height: 23.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098205687105668159150000012690116700515163818_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.3998,
    y1: -319.3126,
    x2: 415.3998,
    y2: -295.3036,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 410.2,
    y: 697.2,
    style: {
      fill: "url(#SVGID_00000098205687105668159150000012690116700515163818_)"
    },
    width: 10.3,
    height: 23.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178895336543894250500000015515856587502763171_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.7293,
    y1: -319.3126,
    x2: 433.7293,
    y2: -295.3036,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 428.6,
    y: 697.2,
    style: {
      fill: "url(#SVGID_00000178895336543894250500000015515856587502763171_)"
    },
    width: 10.3,
    height: 23.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006698923204402266620000009903475132407002497_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.7852,
    y1: -367.5562,
    x2: 602.7852,
    y2: -343.547,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 597.6,
    y: 745.5,
    style: {
      fill: "url(#SVGID_00000006698923204402266620000009903475132407002497_)"
    },
    width: 10.3,
    height: 23.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165948646510888565060000007852460740830035367_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.9844,
    y1: -367.5562,
    x2: 372.9844,
    y2: -343.547,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EFFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C4BE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 367.8,
    y: 745.5,
    style: {
      fill: "url(#SVGID_00000165948646510888565060000007852460740830035367_)"
    },
    width: 10.3,
    height: 23.9
  }), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st184",
    points: "678.5,739.4 321.5,739.4 321.6,747.1 677.6,751.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173871976448329136860000005190226398000758403_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.4227,
    y1: -380.6599,
    x2: 693.6754,
    y2: -380.6599,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00198413,
    style: {
      stopColor: "#BA0C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    style: {
      stopColor: "#A10C37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF3E38"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000173871976448329136860000005190226398000758403_)"
    },
    points: "691.9,789.5 307.4,789.5  305.4,775.8 693.7,779.2  "
  }), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "307.4,777.1 386.6,777.1 387.8,788 308.6,788  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "389.2,777.1 397.7,777.1 399.2,788 390.1,788  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "668.8,780.1 667,787.7 691.9,787.7 693.4,780.5  "
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000060021204159007416970000012679587532967644315_",
    cx: -32.8519,
    cy: -318.1258,
    r: 777.8994,
    gradientTransform: "matrix(1.1373 0 0 -1.4906 134.1073 312.6384)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B6A89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14133E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000060021204159007416970000012679587532967644315_)"
    },
    points: "1193.1,802.2 1198.9,788.4  -0.6,785.3 -0.6,793.8  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilgasM);
export default __webpack_public_path__ + "static/media/oilgas_m.cbd05e6946649b16180207d201029062.svg";
export { ForwardRef as ReactComponent };